var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 56,
    viewBox: "0 0 94 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.0547 28.0464V39.1854C64.0547 41.0972 63.193 42.8757 61.8094 43.7945L51.0801 50.9231C49.2838 52.1235 47.0991 52.1235 45.3028 50.9231L34.5735 43.7945C33.1899 42.8757 32.3281 41.112 32.3281 39.1854V28.0464L45.8004 33.3611L48.1914 31.7753L50.5825 33.3611L64.0547 28.0464Z",
    fill: "url(#paint0_linear_578_447472)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0547 28.0464V39.1854C64.0547 41.0972 63.193 42.8757 61.8094 43.7945L51.0801 50.9231C49.2838 52.1235 47.0991 52.1235 45.3028 50.9231L34.5735 43.7945C33.1899 42.8757 32.3281 41.112 32.3281 39.1854V28.0464L45.8004 33.3611L48.1914 31.7753L50.5825 33.3611L64.0547 28.0464Z",
    fill: "url(#paint1_radial_578_447472)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9795 39.4727C38.9924 39.4922 38.9924 39.5175 38.9794 39.5369C38.7452 39.8877 38.482 40.2238 38.197 40.5381C38.1816 40.5535 38.1661 40.5767 38.1429 40.5921C38.0579 40.6846 37.9652 40.7772 37.8725 40.8697C37.6561 41.0856 37.4397 41.2861 37.2002 41.4711C36.9858 41.6482 36.7644 41.8111 36.5292 41.9666C36.5097 41.9795 36.4844 41.9795 36.4651 41.9663C36.0922 41.7123 35.5091 41.217 35.0202 40.7218C34.5816 40.2774 34.1329 39.6768 34.0252 39.5303C34.0106 39.5104 34.0103 39.4837 34.0245 39.4634C34.0947 39.3629 34.3063 39.0624 34.4337 38.9034C34.6501 38.6335 34.8819 38.3713 35.1215 38.1246C35.2528 37.9935 35.3842 37.8701 35.5233 37.7467C35.8226 37.4855 36.1363 37.2458 36.4645 37.0209C36.4841 37.0075 36.5099 37.0074 36.5296 37.0206C36.7731 37.1836 37.0092 37.354 37.2311 37.5385C37.4552 37.7236 37.6638 37.9164 37.8648 38.1169C38.2881 38.5468 38.6597 38.9916 38.9795 39.4727Z",
    fill: "url(#paint2_diamond_578_447472)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9795 39.4727C38.9924 39.4922 38.9924 39.5175 38.9794 39.5369C38.7452 39.8877 38.482 40.2238 38.197 40.5381C38.1816 40.5535 38.1661 40.5767 38.1429 40.5921C38.0579 40.6846 37.9652 40.7772 37.8725 40.8697C37.6561 41.0856 37.4397 41.2861 37.2002 41.4711C36.9858 41.6482 36.7644 41.8111 36.5292 41.9666C36.5097 41.9795 36.4844 41.9795 36.4651 41.9663C36.0922 41.7123 35.5091 41.217 35.0202 40.7218C34.5816 40.2774 34.1329 39.6768 34.0252 39.5303C34.0106 39.5104 34.0103 39.4837 34.0245 39.4634C34.0947 39.3629 34.3063 39.0624 34.4337 38.9034C34.6501 38.6335 34.8819 38.3713 35.1215 38.1246C35.2528 37.9935 35.3842 37.8701 35.5233 37.7467C35.8226 37.4855 36.1363 37.2458 36.4645 37.0209C36.4841 37.0075 36.5099 37.0074 36.5296 37.0206C36.7731 37.1836 37.0092 37.354 37.2311 37.5385C37.4552 37.7236 37.6638 37.9164 37.8648 38.1169C38.2881 38.5468 38.6597 38.9916 38.9795 39.4727Z",
    fill: "url(#paint3_radial_578_447472)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3604 39.502C38.182 39.7721 37.9805 40.0306 37.7618 40.272C37.7503 40.2835 37.7388 40.3007 37.7216 40.3122C37.6583 40.3811 37.5892 40.4501 37.5201 40.5191C37.359 40.6799 37.1978 40.8293 37.0194 40.9672C36.8525 41.1052 36.6798 41.2316 36.4957 41.3522C36.2194 41.1684 35.9604 40.9672 35.713 40.7489C35.3158 40.3926 34.9648 39.9904 34.6655 39.5422C34.654 39.525 34.6425 39.5135 34.6367 39.4963C34.7403 39.3469 34.8439 39.1975 34.959 39.0538C35.1202 38.8527 35.2928 38.6573 35.4712 38.4734C35.5691 38.3758 35.6669 38.2838 35.7705 38.1919C36.0007 37.9908 36.2424 37.8069 36.4957 37.6345C36.6856 37.7609 36.8698 37.8931 37.0424 38.0367C37.2093 38.1747 37.3647 38.3183 37.5144 38.4677C37.8367 38.7952 38.1187 39.1342 38.3604 39.502Z",
    fill: "url(#paint4_radial_578_447472)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3609 39.5023H36.502V37.6521C36.8703 37.8934 37.2156 38.175 37.5264 38.4853C37.8372 38.7956 38.1192 39.1346 38.3609 39.5023Z",
    fill: "url(#paint5_radial_578_447472)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5015 37.6521V39.5081H34.6426C34.8843 39.1403 35.1663 38.7956 35.4771 38.4853C35.7936 38.175 36.1332 37.8934 36.5015 37.6521Z",
    fill: "url(#paint6_radial_578_447472)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5015 39.5024V41.3584C35.7649 40.87 35.1318 40.2379 34.6426 39.5024H36.5015Z",
    fill: "url(#paint7_radial_578_447472)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3609 39.5024C38.1192 39.8702 37.8372 40.215 37.5264 40.5252C37.2156 40.8355 36.8703 41.1171 36.502 41.3584V39.5024H38.3609Z",
    fill: "url(#paint8_radial_578_447472)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3594 39.502C38.1177 39.8697 37.8357 40.2145 37.5249 40.5248C37.2141 40.8351 36.8688 41.1166 36.5005 41.358C36.2242 41.1741 36.1264 41.1109 35.8789 40.8925L37.0472 38.054C37.2141 38.1919 37.3695 38.3355 37.5192 38.4849C37.8357 38.7952 38.1177 39.1342 38.3594 39.502Z",
    fill: "url(#paint9_radial_578_447472)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.727 40.3176C37.6637 40.3865 37.5946 40.4555 37.5255 40.5244C37.2147 40.8347 36.8694 41.1163 36.5011 41.3576C36.2248 41.1737 35.9658 40.9726 35.7184 40.7543C35.3212 40.398 34.9702 39.9958 34.6709 39.5476C35.4479 39.7775 36.5874 40.0935 37.727 40.3176Z",
    fill: "url(#paint10_radial_578_447472)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7622 40.2721C37.7507 40.2836 37.7391 40.3008 37.7219 40.3123C37.6586 40.3813 37.5895 40.4502 37.5204 40.5192C37.3593 40.6801 37.1981 40.8295 37.0197 40.9674C36.5823 40.1917 36.0989 39.2608 36.0586 38.8988C36.0643 38.9045 37.0312 39.7033 37.7622 40.2721Z",
    fill: "url(#paint11_radial_578_447472)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5015 39.5024L34.9648 39.0599C35.126 38.8588 35.2987 38.6634 35.4771 38.4796C35.5749 38.3819 35.6727 38.2899 35.7763 38.198L36.5015 39.5024Z",
    fill: "url(#paint12_radial_578_447472)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5013 40.7265C36.0178 40.4047 35.5977 39.991 35.2754 39.5026C35.5977 39.0199 36.0121 38.6005 36.5013 38.2787C36.9847 38.6005 37.4048 39.0142 37.7271 39.5026C37.4048 39.991 36.9905 40.4047 36.5013 40.7265Z",
    fill: "url(#paint13_radial_578_447472)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9649 39.1457C35.126 38.9446 35.2987 38.7493 35.4771 38.5654C35.5749 38.4677 35.6728 38.3758 35.7764 38.2838C36.0066 38.0827 36.2483 37.8988 36.5015 37.7265C36.6915 37.8529 36.8756 37.985 37.0483 38.1287C37.2152 38.2666 37.3706 38.4102 37.5202 38.5596C37.8195 38.8584 38.09 39.186 38.326 39.5365C38.3375 39.5192 38.3432 39.5077 38.3547 39.4905C38.113 39.1228 37.831 38.778 37.5202 38.4677C37.3706 38.3183 37.2094 38.1747 37.0483 38.0367C36.8756 37.8931 36.6915 37.7552 36.5015 37.6345C36.2483 37.8012 36.0066 37.9908 35.7764 38.1919C35.6728 38.2838 35.5749 38.3758 35.4771 38.4734C35.2929 38.6573 35.1203 38.8469 34.9649 39.0538C34.8498 39.1975 34.7462 39.3469 34.6426 39.4963C34.6541 39.5135 34.6598 39.525 34.6714 39.5422C34.7692 39.4101 34.867 39.2779 34.9649 39.1457Z",
    fill: "url(#paint14_radial_578_447472)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7618 40.1861C37.7503 40.1975 37.7388 40.2148 37.7216 40.2263C37.6583 40.2952 37.5892 40.3642 37.5201 40.4331C37.359 40.594 37.1978 40.7434 37.0194 40.8813C36.8525 41.0192 36.6798 41.1456 36.4957 41.2663C36.2194 41.0824 35.9604 40.8813 35.713 40.663C35.3158 40.3067 34.9648 39.9045 34.6655 39.4563C34.654 39.4735 34.6425 39.485 34.6367 39.5023C34.6482 39.5195 34.6597 39.531 34.6655 39.5482C34.9648 39.9907 35.3158 40.3929 35.713 40.7549C35.9547 40.9733 36.2194 41.1801 36.4957 41.3583C36.6741 41.2376 36.8525 41.1112 37.0194 40.9733C37.1921 40.8296 37.359 40.6802 37.5201 40.5251C37.5892 40.4561 37.6525 40.3872 37.7216 40.3182C37.7331 40.3067 37.7446 40.2895 37.7618 40.278C37.9805 40.0367 38.1762 39.7781 38.3604 39.508C38.3489 39.4908 38.3374 39.4793 38.3316 39.462C38.159 39.7149 37.969 39.9562 37.7618 40.1861Z",
    fill: "url(#paint15_radial_578_447472)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4772 38.5654C35.2988 38.7493 35.1261 38.9446 34.965 39.1457L34.6987 39.5055C34.9906 39.9339 35.3304 40.3197 35.713 40.6629C35.9604 40.8813 36.2194 41.0824 36.4957 41.2662C36.6798 41.1456 36.8525 41.0192 37.0194 40.8813C37.1978 40.7434 37.359 40.594 37.5201 40.4331C37.5892 40.3641 37.6583 40.2952 37.7216 40.2262C37.7334 40.2183 37.7425 40.2078 37.7507 40.1983C37.7546 40.1938 37.7582 40.1896 37.7618 40.186C37.9578 39.9686 38.1383 39.7409 38.3034 39.503C38.0728 39.1651 37.8101 38.8489 37.5204 38.5596C37.3707 38.4102 37.2153 38.2666 37.0484 38.1287C36.8758 37.985 36.6916 37.8529 36.5017 37.7265C36.2484 37.8988 36.0067 38.0827 35.7765 38.2838C35.6729 38.3758 35.5751 38.4677 35.4772 38.5654ZM38.3516 39.4955C38.3526 39.4939 38.3537 39.4922 38.3549 39.4905C38.1131 39.1228 37.8311 38.778 37.5204 38.4677C37.3707 38.3183 37.2096 38.1747 37.0484 38.0367C36.8758 37.8931 36.6916 37.7552 36.5017 37.6345C36.2484 37.8012 36.0067 37.9908 35.7765 38.1919C35.6729 38.2838 35.5751 38.3758 35.4772 38.4734C35.2931 38.6573 35.1204 38.8469 34.965 39.0538C34.8592 39.1858 34.7632 39.3226 34.6679 39.4599C34.6671 39.4587 34.6663 39.4574 34.6655 39.4562C34.6621 39.4614 34.6586 39.466 34.6553 39.4704C34.6476 39.4808 34.6408 39.4901 34.6367 39.5022C34.6402 39.5073 34.6436 39.512 34.6469 39.5164C34.6546 39.5268 34.6615 39.5361 34.6655 39.5482C34.9648 39.9906 35.3158 40.3928 35.713 40.7548C35.9547 40.9732 36.2194 41.1801 36.4957 41.3582C36.6741 41.2375 36.8525 41.1111 37.0194 40.9732C37.1921 40.8295 37.359 40.6801 37.5201 40.525C37.5547 40.4905 37.5877 40.456 37.6208 40.4216C37.6539 40.3871 37.687 40.3526 37.7216 40.3181C37.7252 40.3145 37.7288 40.3103 37.7327 40.3059C37.7409 40.2963 37.75 40.2858 37.7618 40.2779C37.9805 40.0366 38.1762 39.778 38.3604 39.5079C38.3574 39.5035 38.3544 39.4994 38.3516 39.4955Z",
    fill: "url(#paint16_radial_578_447472)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.502 38.2833C36.502 38.2833 37.2271 38.7373 37.7278 39.5072C37.7278 39.5015 37.371 38.7085 36.502 38.2833Z",
    fill: "url(#paint17_radial_578_447472)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2812 39.5027C35.2812 39.5027 35.7129 40.2612 36.4438 40.7151L36.5014 41.2667L36.5417 40.7036C36.5417 40.7036 37.0884 40.4738 37.7273 39.5027C37.7273 39.5027 36.9215 40.5829 36.4899 40.6404C36.4899 40.6462 35.9892 40.4508 35.2812 39.5027Z",
    fill: "url(#paint18_radial_578_447472)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5068 40.7208C36.5068 40.7208 37.2665 40.2898 37.7212 39.5601L38.2737 39.5026L37.7097 39.4624C37.7097 39.4624 37.4795 38.9165 36.5068 38.2787C36.5068 38.2787 37.5888 39.0831 37.6464 39.5141C37.6521 39.5141 37.4565 40.014 36.5068 40.7208Z",
    fill: "url(#paint19_radial_578_447472)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4788 38.2787C36.4788 38.2787 35.7191 38.7096 35.2644 39.4394L34.7119 39.4969L35.2759 39.5371C35.2759 39.5371 35.5061 40.083 36.4788 40.7208C36.4788 40.7208 35.3968 39.9163 35.3392 39.4854C35.3335 39.4854 35.5292 38.9855 36.4788 38.2787Z",
    fill: "url(#paint20_radial_578_447472)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7273 39.4961C37.7273 39.4961 37.2956 38.7376 36.5647 38.2837L36.5071 37.7321L36.4668 38.2952C36.4668 38.2952 35.9201 38.525 35.2812 39.4961C35.2812 39.4961 36.087 38.4158 36.5186 38.3584C36.5186 38.3526 37.0194 38.548 37.7273 39.4961Z",
    fill: "url(#paint21_radial_578_447472)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.709 43.197C44.7219 43.2164 44.7219 43.2417 44.7089 43.2611C44.4747 43.612 44.2115 43.9481 43.9265 44.2624C43.9111 44.2778 43.8956 44.3009 43.8724 44.3163C43.7874 44.4089 43.6947 44.5014 43.602 44.5939C43.3856 44.8098 43.1692 45.0103 42.9297 45.1954C42.7153 45.3724 42.4939 45.5353 42.2587 45.6908C42.2392 45.7037 42.2139 45.7037 42.1946 45.6905C41.8217 45.4366 41.2386 44.9413 40.7497 44.446C40.311 44.0016 39.8624 43.401 39.7547 43.2546C39.7401 43.2346 39.7398 43.208 39.754 43.1877C39.8242 43.0872 40.0358 42.7866 40.1632 42.6276C40.3796 42.3577 40.6114 42.0956 40.851 41.8488C40.9823 41.7177 41.1137 41.5944 41.2528 41.471C41.5521 41.2097 41.8658 40.9701 42.194 40.7452C42.2136 40.7317 42.2394 40.7316 42.2591 40.7448C42.5026 40.9079 42.7387 41.0783 42.9606 41.2628C43.1847 41.4479 43.3933 41.6406 43.5942 41.8411C44.0176 42.2711 44.3892 42.7158 44.709 43.197Z",
    fill: "#643020"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0899 43.2262C43.9115 43.4963 43.71 43.7549 43.4913 43.9962C43.4798 44.0077 43.4683 44.0249 43.4511 44.0364C43.3877 44.1054 43.3187 44.1743 43.2496 44.2433C43.0885 44.4042 42.9273 44.5536 42.7489 44.6915C42.582 44.8294 42.4093 44.9558 42.2252 45.0765C41.9489 44.8926 41.6899 44.6915 41.4425 44.4731C41.0453 44.1169 40.6943 43.7147 40.395 43.2665C40.3835 43.2492 40.372 43.2377 40.3662 43.2205C40.4698 43.0711 40.5734 42.9217 40.6885 42.778C40.8497 42.5769 41.0223 42.3816 41.2007 42.1977C41.2986 42.1 41.3964 42.0081 41.5 41.9161C41.7302 41.715 41.9719 41.5311 42.2252 41.3588C42.4151 41.4852 42.5993 41.6173 42.7719 41.761C42.9388 41.8989 43.0942 42.0425 43.2439 42.1919C43.5662 42.5195 43.8482 42.8585 44.0899 43.2262Z",
    fill: "url(#paint22_radial_578_447472)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0904 43.2266H42.2314V41.3763C42.5998 41.6177 42.9451 41.8992 43.2559 42.2095C43.5667 42.5198 43.8487 42.8588 44.0904 43.2266Z",
    fill: "url(#paint23_radial_578_447472)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.231 41.3763V43.2323H40.3721C40.6138 42.8646 40.8958 42.5198 41.2066 42.2095C41.5231 41.8992 41.8627 41.6177 42.231 41.3763Z",
    fill: "url(#paint24_radial_578_447472)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.231 43.2267V45.0827C41.4944 44.5943 40.8613 43.9622 40.3721 43.2267H42.231Z",
    fill: "url(#paint25_radial_578_447472)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0904 43.2267C43.8487 43.5944 43.5667 43.9392 43.2559 44.2495C42.9451 44.5598 42.5998 44.8413 42.2314 45.0827V43.2267H44.0904Z",
    fill: "url(#paint26_radial_578_447472)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0889 43.2262C43.8472 43.594 43.5652 43.9387 43.2544 44.249C42.9436 44.5593 42.5983 44.8409 42.23 45.0822C41.9537 44.8983 41.8559 44.8351 41.6084 44.6168L42.7767 41.7782C42.9436 41.9161 43.099 42.0598 43.2487 42.2092C43.5652 42.5194 43.8472 42.8585 44.0889 43.2262Z",
    fill: "url(#paint27_radial_578_447472)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4565 44.0418C43.3931 44.1108 43.3241 44.1797 43.255 44.2487C42.9442 44.559 42.5989 44.8405 42.2306 45.0819C41.9543 44.898 41.6953 44.6969 41.4479 44.4785C41.0507 44.1223 40.6997 43.72 40.4004 43.2719C41.1774 43.5017 42.3169 43.8177 43.4565 44.0418Z",
    fill: "url(#paint28_radial_578_447472)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4917 43.9964C43.4801 44.0079 43.4686 44.0251 43.4514 44.0366C43.3881 44.1055 43.319 44.1745 43.2499 44.2434C43.0888 44.4043 42.9276 44.5537 42.7492 44.6916C42.3118 43.9159 41.8284 42.985 41.7881 42.623C41.7938 42.6288 42.7607 43.4275 43.4917 43.9964Z",
    fill: "url(#paint29_radial_578_447472)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M42.231 43.2266L40.6943 42.7842C40.8555 42.583 41.0281 42.3877 41.2066 42.2038C41.3044 42.1061 41.4022 42.0142 41.5058 41.9222L42.231 43.2266Z",
    fill: "url(#paint30_radial_578_447472)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2308 44.4508C41.7473 44.129 41.3272 43.7153 41.0049 43.2268C41.3272 42.7442 41.7416 42.3247 42.2308 42.0029C42.7142 42.3247 43.1343 42.7384 43.4566 43.2268C43.1343 43.7153 42.72 44.129 42.2308 44.4508Z",
    fill: "url(#paint31_radial_578_447472)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6944 42.87C40.8555 42.6689 41.0282 42.4735 41.2066 42.2896C41.3044 42.1919 41.4023 42.1 41.5059 42.0081C41.7361 41.807 41.9778 41.6231 42.231 41.4507C42.421 41.5771 42.6051 41.7093 42.7778 41.8529C42.9447 41.9908 43.1001 42.1345 43.2497 42.2839C43.549 42.5827 43.8195 42.9102 44.0555 43.2607C44.067 43.2435 44.0727 43.232 44.0842 43.2147C43.8425 42.847 43.5605 42.5022 43.2497 42.1919C43.1001 42.0425 42.9389 41.8989 42.7778 41.761C42.6051 41.6173 42.421 41.4794 42.231 41.3588C41.9778 41.5254 41.7361 41.715 41.5059 41.9161C41.4023 42.0081 41.3044 42.1 41.2066 42.1977C41.0224 42.3816 40.8498 42.5712 40.6944 42.778C40.5793 42.9217 40.4757 43.0711 40.3721 43.2205C40.3836 43.2377 40.3893 43.2492 40.4008 43.2665C40.4987 43.1343 40.5965 43.0021 40.6944 42.87Z",
    fill: "url(#paint32_radial_578_447472)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4913 43.9103C43.4798 43.9218 43.4683 43.939 43.4511 43.9505C43.3877 44.0195 43.3187 44.0884 43.2496 44.1574C43.0885 44.3183 42.9273 44.4677 42.7489 44.6056C42.582 44.7435 42.4093 44.8699 42.2252 44.9906C41.9489 44.8067 41.6899 44.6056 41.4425 44.3872C41.0453 44.031 40.6943 43.6287 40.395 43.1805C40.3835 43.1978 40.372 43.2093 40.3662 43.2265C40.3777 43.2437 40.3892 43.2552 40.395 43.2725C40.6943 43.7149 41.0453 44.1172 41.4425 44.4792C41.6842 44.6975 41.9489 44.9044 42.2252 45.0825C42.4036 44.9618 42.582 44.8354 42.7489 44.6975C42.9216 44.5539 43.0885 44.4045 43.2496 44.2493C43.3187 44.1804 43.382 44.1114 43.4511 44.0425C43.4626 44.031 43.4741 44.0137 43.4913 44.0022C43.71 43.7609 43.9057 43.5023 44.0899 43.2323C44.0784 43.215 44.0669 43.2035 44.0611 43.1863C43.8885 43.4391 43.6985 43.6805 43.4913 43.9103Z",
    fill: "url(#paint33_radial_578_447472)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2067 42.2896C41.0283 42.4735 40.8556 42.6689 40.6945 42.87L40.4282 43.2297C40.7201 43.6582 41.0599 44.044 41.4425 44.3871C41.6899 44.6055 41.9489 44.8066 42.2252 44.9905C42.4093 44.8698 42.582 44.7434 42.7489 44.6055C42.9273 44.4676 43.0885 44.3182 43.2496 44.1573C43.3187 44.0884 43.3877 44.0194 43.4511 43.9504C43.4629 43.9426 43.472 43.9321 43.4802 43.9225C43.484 43.9181 43.4877 43.9139 43.4913 43.9102C43.6873 43.6928 43.8678 43.4652 44.0329 43.2272C43.8023 42.8893 43.5396 42.5731 43.2498 42.2839C43.1002 42.1345 42.9448 41.9908 42.7779 41.8529C42.6052 41.7093 42.4211 41.5771 42.2312 41.4507C41.9779 41.6231 41.7362 41.807 41.506 42.0081C41.4024 42.1 41.3046 42.1919 41.2067 42.2896ZM44.0811 43.2198C44.0821 43.2181 44.0832 43.2165 44.0844 43.2147C43.8426 42.847 43.5606 42.5022 43.2498 42.1919C43.1002 42.0425 42.9391 41.8989 42.7779 41.761C42.6052 41.6173 42.4211 41.4794 42.2312 41.3588C41.9779 41.5254 41.7362 41.715 41.506 41.9161C41.4024 42.0081 41.3046 42.1 41.2067 42.1977C41.0225 42.3816 40.8499 42.5712 40.6945 42.778C40.5887 42.91 40.4927 43.0469 40.3974 43.1841C40.3966 43.1829 40.3958 43.1817 40.395 43.1805C40.3916 43.1856 40.3881 43.1902 40.3848 43.1947C40.3771 43.2051 40.3702 43.2143 40.3662 43.2264C40.3696 43.2316 40.3731 43.2362 40.3764 43.2406C40.3841 43.251 40.3909 43.2603 40.395 43.2724C40.6943 43.7149 41.0453 44.1171 41.4425 44.4791C41.6842 44.6974 41.9489 44.9043 42.2252 45.0824C42.4036 44.9618 42.582 44.8353 42.7489 44.6974C42.9216 44.5538 43.0885 44.4044 43.2496 44.2492C43.2841 44.2148 43.3172 44.1803 43.3503 44.1458C43.3834 44.1113 43.4165 44.0769 43.4511 44.0424C43.4547 44.0387 43.4583 44.0345 43.4622 44.0301C43.4704 44.0206 43.4795 44.01 43.4913 44.0022C43.71 43.7608 43.9057 43.5023 44.0899 43.2322C44.0869 43.2277 44.0839 43.2237 44.0811 43.2198Z",
    fill: "url(#paint34_radial_578_447472)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2314 42.0076C42.2314 42.0076 42.9566 42.4615 43.4573 43.2315C43.4573 43.2257 43.1005 42.4328 42.2314 42.0076Z",
    fill: "url(#paint35_radial_578_447472)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0107 43.2269C41.0107 43.2269 41.4424 43.9854 42.1733 44.4394L42.2309 44.991L42.2712 44.4279C42.2712 44.4279 42.8179 44.198 43.4567 43.2269C43.4567 43.2269 42.651 44.3072 42.2194 44.3647C42.2194 44.3704 41.7186 44.175 41.0107 43.2269Z",
    fill: "url(#paint36_radial_578_447472)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2363 44.445C42.2363 44.445 42.996 44.0141 43.4507 43.2843L44.0032 43.2268L43.4392 43.1866C43.4392 43.1866 43.209 42.6407 42.2363 42.0029C42.2363 42.0029 43.3183 42.8074 43.3759 43.2383C43.3816 43.2383 43.186 43.7382 42.2363 44.445Z",
    fill: "url(#paint37_radial_578_447472)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2083 42.0029C42.2083 42.0029 41.4486 42.4339 40.9939 43.1636L40.4414 43.2211L41.0054 43.2613C41.0054 43.2613 41.2356 43.8072 42.2083 44.445C42.2083 44.445 41.1263 43.6406 41.0687 43.2096C41.063 43.2096 41.2587 42.7097 42.2083 42.0029Z",
    fill: "url(#paint38_radial_578_447472)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4567 43.2203C43.4567 43.2203 43.0251 42.4619 42.2942 42.0079L42.2366 41.4563L42.1963 42.0194C42.1963 42.0194 41.6496 42.2493 41.0107 43.2203C41.0107 43.2203 41.8165 42.1401 42.2481 42.0826C42.2481 42.0769 42.7488 42.2722 43.4567 43.2203Z",
    fill: "url(#paint39_radial_578_447472)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7998 46.5761C50.8127 46.5956 50.8127 46.6209 50.7997 46.6403C50.5655 46.9911 50.3023 47.3272 50.0174 47.6415C50.0019 47.6569 49.9864 47.6801 49.9633 47.6955C49.8783 47.788 49.7855 47.8805 49.6928 47.9731C49.4764 48.189 49.2601 48.3895 49.0205 48.5745C48.8061 48.7515 48.5847 48.9144 48.3495 49.07C48.33 49.0829 48.3047 49.0829 48.2854 49.0697C47.9125 48.8157 47.3294 48.3204 46.8405 47.8251C46.4019 47.3807 45.9532 46.7802 45.8455 46.6337C45.8309 46.6138 45.8306 46.5871 45.8448 46.5668C45.915 46.4663 46.1266 46.1658 46.254 46.0068C46.4704 45.7369 46.7022 45.4747 46.9418 45.228C47.0732 45.0969 47.2045 44.9735 47.3436 44.8501C47.6429 44.5888 47.9566 44.3492 48.2849 44.1243C48.3044 44.1109 48.3302 44.1108 48.35 44.124C48.5934 44.287 48.8295 44.4574 49.0514 44.6419C49.2755 44.827 49.4842 45.0198 49.6851 45.2203C50.1084 45.6502 50.48 46.095 50.7998 46.5761Z",
    fill: "#643020"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1807 46.6054C50.0023 46.8755 49.8009 47.134 49.5822 47.3754C49.5706 47.3869 49.5591 47.4041 49.5419 47.4156C49.4786 47.4845 49.4095 47.5535 49.3404 47.6224C49.1793 47.7833 49.0181 47.9327 48.8397 48.0706C48.6728 48.2085 48.5002 48.335 48.316 48.4556C48.0397 48.2718 47.7807 48.0706 47.5333 47.8523C47.1362 47.496 46.7851 47.0938 46.4858 46.6456C46.4743 46.6284 46.4628 46.6169 46.457 46.5996C46.5606 46.4502 46.6642 46.3008 46.7793 46.1572C46.9405 45.9561 47.1131 45.7607 47.2915 45.5768C47.3894 45.4792 47.4872 45.3872 47.5908 45.2953C47.821 45.0942 48.0628 44.9103 48.316 44.7379C48.5059 44.8643 48.6901 44.9965 48.8627 45.1401C49.0296 45.278 49.185 45.4217 49.3347 45.5711C49.657 45.8986 49.939 46.2376 50.1807 46.6054Z",
    fill: "url(#paint40_radial_578_447472)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1803 46.6059H48.3213V44.7556C48.6896 44.997 49.0349 45.2785 49.3457 45.5888C49.6565 45.8991 49.9385 46.2381 50.1803 46.6059Z",
    fill: "url(#paint41_radial_578_447472)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3209 44.7559V46.6118H46.4619C46.7036 46.2441 46.9856 45.8993 47.2964 45.589C47.613 45.2788 47.9525 44.9972 48.3209 44.7559Z",
    fill: "url(#paint42_radial_578_447472)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3209 46.6058V48.4618C47.5842 47.9734 46.9511 47.3413 46.4619 46.6058H48.3209Z",
    fill: "url(#paint43_radial_578_447472)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1803 46.606C49.9385 46.9737 49.6565 47.3185 49.3457 47.6288C49.0349 47.939 48.6896 48.2206 48.3213 48.4619V46.606H50.1803Z",
    fill: "url(#paint44_radial_578_447472)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1798 46.6055C49.938 46.9732 49.656 47.318 49.3452 47.6283C49.0344 47.9386 48.6891 48.2201 48.3208 48.4615C48.0445 48.2776 47.9467 48.2144 47.6992 47.996L48.8675 45.1575C49.0344 45.2954 49.1898 45.439 49.3395 45.5884C49.656 45.8987 49.938 46.2377 50.1798 46.6055Z",
    fill: "url(#paint45_radial_578_447472)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5473 47.421C49.484 47.4899 49.4149 47.5589 49.3458 47.6278C49.0351 47.9381 48.6897 48.2197 48.3214 48.461C48.0451 48.2771 47.7862 48.076 47.5387 47.8577C47.1416 47.5014 46.7905 47.0992 46.4912 46.651C47.2682 46.8808 48.4077 47.1969 49.5473 47.421Z",
    fill: "url(#paint46_radial_578_447472)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5825 47.3756C49.571 47.3871 49.5595 47.4044 49.5422 47.4159C49.4789 47.4848 49.4098 47.5538 49.3408 47.6227C49.1796 47.7836 49.0185 47.933 48.84 48.0709C48.4026 47.2952 47.9192 46.3643 47.8789 46.0023C47.8847 46.0081 48.8516 46.8068 49.5825 47.3756Z",
    fill: "url(#paint47_radial_578_447472)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3218 46.6058L46.7852 46.1633C46.9463 45.9622 47.119 45.7668 47.2974 45.5829C47.3952 45.4853 47.4931 45.3933 47.5967 45.3014L48.3218 46.6058Z",
    fill: "url(#paint48_radial_578_447472)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3216 47.8299C47.8381 47.5081 47.418 47.0944 47.0957 46.606C47.418 46.1233 47.8324 45.7039 48.3216 45.3821C48.805 45.7039 49.2252 46.1176 49.5475 46.606C49.2252 47.0944 48.8108 47.5081 48.3216 47.8299Z",
    fill: "url(#paint49_radial_578_447472)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7852 46.2493C46.9463 46.0481 47.119 45.8528 47.2974 45.6689C47.3952 45.5712 47.4931 45.4793 47.5967 45.3873C47.8269 45.1862 48.0686 45.0024 48.3219 44.83C48.5118 44.9564 48.6959 45.0885 48.8686 45.2322C49.0355 45.3701 49.1909 45.5138 49.3405 45.6632C49.6398 45.962 49.9103 46.2895 50.1463 46.64C50.1578 46.6227 50.1635 46.6113 50.1751 46.594C49.9333 46.2263 49.6513 45.8815 49.3405 45.5712C49.1909 45.4218 49.0298 45.2782 48.8686 45.1403C48.6959 44.9966 48.5118 44.8587 48.3219 44.738C48.0686 44.9047 47.8269 45.0943 47.5967 45.2954C47.4931 45.3873 47.3952 45.4793 47.2974 45.577C47.1132 45.7608 46.9406 45.9505 46.7852 46.1573C46.6701 46.301 46.5665 46.4504 46.4629 46.5998C46.4744 46.617 46.4802 46.6285 46.4917 46.6457C46.5895 46.5136 46.6873 46.3814 46.7852 46.2493Z",
    fill: "url(#paint50_radial_578_447472)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5822 47.2894C49.5706 47.3009 49.5591 47.3182 49.5419 47.3297C49.4786 47.3986 49.4095 47.4676 49.3404 47.5365C49.1793 47.6974 49.0181 47.8468 48.8397 47.9847C48.6728 48.1226 48.5002 48.249 48.316 48.3697C48.0397 48.1858 47.7807 47.9847 47.5333 47.7664C47.1362 47.4101 46.7851 47.0079 46.4858 46.5597C46.4743 46.5769 46.4628 46.5884 46.457 46.6057C46.4685 46.6229 46.4801 46.6344 46.4858 46.6516C46.7851 47.0941 47.1362 47.4963 47.5333 47.8583C47.775 48.0767 48.0397 48.2835 48.316 48.4616C48.4944 48.341 48.6728 48.2146 48.8397 48.0767C49.0124 47.933 49.1793 47.7836 49.3404 47.6285C49.4095 47.5595 49.4728 47.4906 49.5419 47.4216C49.5534 47.4101 49.5649 47.3929 49.5822 47.3814C49.8009 47.14 49.9965 46.8815 50.1807 46.6114C50.1692 46.5942 50.1577 46.5827 50.1519 46.5654C49.9793 46.8183 49.7893 47.0596 49.5822 47.2894Z",
    fill: "url(#paint51_radial_578_447472)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2977 45.6688C47.1193 45.8527 46.9466 46.048 46.7855 46.2491L46.5191 46.609C46.811 47.0374 47.1508 47.4232 47.5333 47.7663C47.7807 47.9846 48.0397 48.1858 48.316 48.3696C48.5002 48.249 48.6728 48.1226 48.8397 47.9847C49.0181 47.8467 49.1793 47.6973 49.3404 47.5365C49.4095 47.4675 49.4786 47.3985 49.5419 47.3296C49.5537 47.3217 49.5628 47.3112 49.571 47.3017C49.5749 47.2972 49.5785 47.293 49.5822 47.2894C49.7782 47.072 49.9587 46.8442 50.1238 46.6063C49.8932 46.2684 49.6305 45.9523 49.3408 45.663C49.1912 45.5136 49.0358 45.37 48.8689 45.2321C48.6962 45.0884 48.5121 44.9563 48.3221 44.8299C48.0689 45.0022 47.8272 45.1861 47.597 45.3872C47.4934 45.4792 47.3955 45.5711 47.2977 45.6688ZM50.172 46.599C50.173 46.5974 50.1742 46.5957 50.1753 46.5939C49.9336 46.2261 49.6516 45.8814 49.3408 45.5711C49.1912 45.4217 49.03 45.278 48.8689 45.1401C48.6962 44.9965 48.5121 44.8586 48.3221 44.7379C48.0689 44.9046 47.8272 45.0942 47.597 45.2953C47.4934 45.3872 47.3955 45.4792 47.2977 45.5768C47.1135 45.7607 46.9409 45.9503 46.7855 46.1572C46.6797 46.2892 46.5836 46.4261 46.4883 46.5634C46.4875 46.5621 46.4866 46.5609 46.4858 46.5596C46.4824 46.5648 46.4789 46.5694 46.4757 46.5738C46.4679 46.5842 46.4611 46.5935 46.457 46.6056C46.4605 46.6107 46.4639 46.6154 46.4672 46.6198C46.4749 46.6302 46.4818 46.6395 46.4858 46.6516C46.7851 47.094 47.1362 47.4962 47.5333 47.8582C47.775 48.0766 48.0397 48.2834 48.316 48.4616C48.4944 48.3409 48.6728 48.2145 48.8397 48.0766C49.0124 47.9329 49.1793 47.7835 49.3404 47.6284C49.375 47.5939 49.4081 47.5594 49.4412 47.525C49.4742 47.4905 49.5073 47.456 49.5419 47.4215C49.5455 47.4179 49.5492 47.4137 49.553 47.4093C49.5612 47.3997 49.5704 47.3892 49.5822 47.3813C49.8009 47.14 49.9965 46.8814 50.1807 46.6113C50.1778 46.6069 50.1748 46.6029 50.172 46.599Z",
    fill: "url(#paint52_radial_578_447472)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3223 45.3867C48.3223 45.3867 49.0474 45.8407 49.5481 46.6106C49.5481 46.6049 49.1913 45.8119 48.3223 45.3867Z",
    fill: "url(#paint53_radial_578_447472)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1016 46.6062C47.1016 46.6062 47.5332 47.3647 48.2641 47.8186L48.3217 48.3702L48.362 47.8071C48.362 47.8071 48.9087 47.5773 49.5476 46.6062C49.5476 46.6062 48.7418 47.6865 48.3102 47.7439C48.3102 47.7497 47.8095 47.5543 47.1016 46.6062Z",
    fill: "url(#paint54_radial_578_447472)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3271 47.8242C48.3271 47.8242 49.0868 47.3932 49.5415 46.6635L50.094 46.606L49.53 46.5658C49.53 46.5658 49.2998 46.0199 48.3271 45.3821C48.3271 45.3821 49.4091 46.1865 49.4667 46.6175C49.4725 46.6175 49.2768 47.1174 48.3271 47.8242Z",
    fill: "url(#paint55_radial_578_447472)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2991 45.3821C48.2991 45.3821 47.5394 45.813 47.0847 46.5428L46.5322 46.6002L47.0962 46.6405C47.0962 46.6405 47.3265 47.1863 48.2991 47.8242C48.2991 47.8242 47.2171 47.0197 47.1596 46.5888C47.1538 46.5888 47.3495 46.0888 48.2991 45.3821Z",
    fill: "url(#paint56_radial_578_447472)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5476 46.5995C49.5476 46.5995 49.1159 45.841 48.385 45.3871L48.3274 44.8354L48.2872 45.3986C48.2872 45.3986 47.7404 45.6284 47.1016 46.5995C47.1016 46.5995 47.9073 45.5192 48.339 45.4618C48.339 45.456 48.8397 45.6514 49.5476 46.5995Z",
    fill: "url(#paint57_radial_578_447472)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7764 43.198C56.7893 43.2174 56.7892 43.2427 56.7763 43.2621C56.542 43.6129 56.2789 43.949 55.9939 44.2633C55.9785 44.2788 55.963 44.3019 55.9398 44.3173C55.8548 44.4098 55.7621 44.5024 55.6694 44.5949C55.453 44.8108 55.2366 45.0113 54.9971 45.1964C54.7827 45.3734 54.5613 45.5363 54.326 45.6918C54.3065 45.7047 54.2813 45.7047 54.262 45.6915C53.8891 45.4375 53.306 44.9422 52.8171 44.447C52.3784 44.0026 51.9298 43.402 51.8221 43.2556C51.8074 43.2356 51.8072 43.209 51.8213 43.1887C51.8916 43.0882 52.1031 42.7876 52.2306 42.6286C52.447 42.3587 52.6788 42.0965 52.9183 41.8498C53.0497 41.7187 53.1811 41.5953 53.3202 41.472C53.6194 41.2107 53.9332 40.9711 54.2614 40.7461C54.281 40.7327 54.3068 40.7326 54.3265 40.7458C54.57 40.9088 54.8061 41.0792 55.028 41.2638C55.2521 41.4488 55.4607 41.6416 55.6616 41.8421C56.085 42.2721 56.4565 42.7168 56.7764 43.198Z",
    fill: "#643020"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1573 43.2272C55.9789 43.4973 55.7774 43.7559 55.5587 43.9972C55.5472 44.0087 55.5357 44.0259 55.5184 44.0374C55.4551 44.1064 55.3861 44.1753 55.317 44.2443C55.1559 44.4052 54.9947 44.5546 54.8163 44.6925C54.6494 44.8304 54.4767 44.9568 54.2926 45.0775C54.0163 44.8936 53.7573 44.6925 53.5098 44.4741C53.1127 44.1179 52.7616 43.7156 52.4624 43.2674C52.4509 43.2502 52.4393 43.2387 52.4336 43.2215C52.5372 43.0721 52.6408 42.9227 52.7559 42.779C52.917 42.5779 53.0897 42.3825 53.2681 42.1987C53.366 42.101 53.4638 42.009 53.5674 41.9171C53.7976 41.716 54.0393 41.5321 54.2926 41.3597C54.4825 41.4862 54.6666 41.6183 54.8393 41.762C55.0062 41.8999 55.1616 42.0435 55.3112 42.1929C55.6335 42.5204 55.9155 42.8595 56.1573 43.2272Z",
    fill: "url(#paint58_radial_578_447472)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1578 43.2277H54.2988V41.3774C54.6672 41.6188 55.0125 41.9003 55.3233 42.2106C55.6341 42.5209 55.9161 42.8599 56.1578 43.2277Z",
    fill: "url(#paint59_radial_578_447472)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2984 41.3777V43.2337H52.4395C52.6812 42.8659 52.9632 42.5212 53.274 42.2109C53.5905 41.9006 53.9301 41.619 54.2984 41.3777Z",
    fill: "url(#paint60_radial_578_447472)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2984 43.2277V45.0836C53.5617 44.5952 52.9287 43.9632 52.4395 43.2277H54.2984Z",
    fill: "url(#paint61_radial_578_447472)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1578 43.2278C55.9161 43.5955 55.6341 43.9403 55.3233 44.2506C55.0125 44.5609 54.6672 44.8424 54.2988 45.0838V43.2278H56.1578Z",
    fill: "url(#paint62_radial_578_447472)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1563 43.2273C55.9146 43.5951 55.6326 43.9398 55.3218 44.2501C55.011 44.5604 54.6657 44.842 54.2974 45.0833C54.0211 44.8994 53.9233 44.8362 53.6758 44.6179L54.8441 41.7793C55.011 41.9172 55.1664 42.0609 55.316 42.2103C55.6326 42.5205 55.9146 42.8596 56.1563 43.2273Z",
    fill: "url(#paint63_radial_578_447472)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5238 44.0428C55.4605 44.1118 55.3915 44.1807 55.3224 44.2497C55.0116 44.5599 54.6663 44.8415 54.298 45.0828C54.0217 44.899 53.7627 44.6979 53.5152 44.4795C53.1181 44.1232 52.767 43.721 52.4678 43.2728C53.2447 43.5027 54.3843 43.8187 55.5238 44.0428Z",
    fill: "url(#paint64_radial_578_447472)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M55.559 43.9973C55.5475 44.0088 55.536 44.0261 55.5188 44.0376C55.4554 44.1065 55.3864 44.1755 55.3173 44.2444C55.1562 44.4053 54.995 44.5547 54.8166 44.6926C54.3792 43.9169 53.8958 42.986 53.8555 42.624C53.8612 42.6298 54.8281 43.4285 55.559 43.9973Z",
    fill: "url(#paint65_radial_578_447472)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2984 43.2276L52.7617 42.7851C52.9229 42.584 53.0955 42.3886 53.2739 42.2048C53.3718 42.1071 53.4696 42.0152 53.5732 41.9232L54.2984 43.2276Z",
    fill: "url(#paint66_radial_578_447472)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2991 44.4517C53.8157 44.13 53.3955 43.7162 53.0732 43.2278C53.3955 42.7452 53.8099 42.3257 54.2991 42.0039C54.7826 42.3257 55.2027 42.7394 55.525 43.2278C55.2027 43.7162 54.7883 44.13 54.2991 44.4517Z",
    fill: "url(#paint67_radial_578_447472)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7617 42.871C52.9229 42.6698 53.0956 42.4745 53.274 42.2906C53.3718 42.1929 53.4697 42.101 53.5732 42.009C53.8035 41.8079 54.0452 41.6241 54.2984 41.4517C54.4883 41.5781 54.6725 41.7103 54.8452 41.8539C55.0121 41.9918 55.1675 42.1355 55.3171 42.2849C55.6164 42.5837 55.8869 42.9112 56.1228 43.2617C56.1344 43.2445 56.1401 43.233 56.1516 43.2157C55.9099 42.848 55.6279 42.5032 55.3171 42.1929C55.1675 42.0435 55.0063 41.8999 54.8452 41.762C54.6725 41.6183 54.4883 41.4804 54.2984 41.3597C54.0452 41.5264 53.8035 41.716 53.5732 41.9171C53.4697 42.009 53.3718 42.101 53.274 42.1987C53.0898 42.3825 52.9171 42.5722 52.7617 42.779C52.6466 42.9227 52.543 43.0721 52.4395 43.2215C52.451 43.2387 52.4567 43.2502 52.4682 43.2674C52.5661 43.1353 52.6639 43.0031 52.7617 42.871Z",
    fill: "url(#paint68_radial_578_447472)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5587 43.9113C55.5472 43.9228 55.5357 43.94 55.5184 43.9515C55.4551 44.0204 55.3861 44.0894 55.317 44.1584C55.1559 44.3192 54.9947 44.4686 54.8163 44.6065C54.6494 44.7445 54.4767 44.8709 54.2926 44.9915C54.0163 44.8077 53.7573 44.6065 53.5098 44.3882C53.1127 44.0319 52.7616 43.6297 52.4624 43.1815C52.4509 43.1988 52.4393 43.2103 52.4336 43.2275C52.4451 43.2447 52.4566 43.2562 52.4624 43.2735C52.7616 43.7159 53.1127 44.1181 53.5098 44.4801C53.7516 44.6985 54.0163 44.9053 54.2926 45.0835C54.471 44.9628 54.6494 44.8364 54.8163 44.6985C54.9889 44.5548 55.1559 44.4054 55.317 44.2503C55.3861 44.1813 55.4494 44.1124 55.5184 44.0434C55.5299 44.0319 55.5415 44.0147 55.5587 44.0032C55.7774 43.7619 55.9731 43.5033 56.1573 43.2332C56.1458 43.216 56.1343 43.2045 56.1285 43.1873C55.9558 43.4401 55.7659 43.6814 55.5587 43.9113Z",
    fill: "url(#paint69_radial_578_447472)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2743 42.2906C53.0959 42.4745 52.9232 42.6698 52.7621 42.871L52.4957 43.2308C52.7876 43.6592 53.1274 44.045 53.5098 44.3881C53.7573 44.6065 54.0163 44.8076 54.2926 44.9915C54.4767 44.8708 54.6494 44.7444 54.8163 44.6065C54.9947 44.4686 55.1559 44.3192 55.317 44.1583C55.3861 44.0893 55.4551 44.0204 55.5184 43.9514C55.5302 43.9436 55.5393 43.933 55.5476 43.9235C55.5514 43.919 55.5551 43.9148 55.5587 43.9112C55.7547 43.6938 55.9353 43.4661 56.1004 43.2281C55.8698 42.8902 55.6071 42.5741 55.3174 42.2849C55.1678 42.1355 55.0124 41.9918 54.8455 41.8539C54.6728 41.7103 54.4886 41.5781 54.2987 41.4517C54.0455 41.6241 53.8038 41.8079 53.5736 42.009C53.47 42.101 53.3721 42.1929 53.2743 42.2906ZM56.1485 43.2209C56.1496 43.2192 56.1507 43.2175 56.1519 43.2157C55.9102 42.848 55.6282 42.5032 55.3174 42.1929C55.1678 42.0435 55.0066 41.8999 54.8455 41.762C54.6728 41.6183 54.4886 41.4804 54.2987 41.3597C54.0455 41.5264 53.8038 41.716 53.5736 41.9171C53.47 42.009 53.3721 42.101 53.2743 42.1987C53.0901 42.3825 52.9174 42.5722 52.7621 42.779C52.6563 42.9111 52.5602 43.0479 52.4649 43.1852C52.4641 43.184 52.4632 43.1827 52.4624 43.1814C52.4589 43.1866 52.4555 43.1912 52.4522 43.1956C52.4445 43.2061 52.4376 43.2153 52.4336 43.2274C52.437 43.2326 52.4405 43.2372 52.4437 43.2416C52.4515 43.252 52.4583 43.2613 52.4624 43.2734C52.7616 43.7158 53.1127 44.1181 53.5098 44.4801C53.7516 44.6984 54.0163 44.9053 54.2926 45.0834C54.471 44.9627 54.6494 44.8363 54.8163 44.6984C54.9889 44.5548 55.1559 44.4054 55.317 44.2502C55.3515 44.2157 55.3846 44.1813 55.4177 44.1468C55.4508 44.1123 55.4839 44.0778 55.5184 44.0434C55.5221 44.0397 55.5257 44.0355 55.5296 44.0311C55.5378 44.0215 55.5469 44.011 55.5587 44.0031C55.7774 43.7618 55.9731 43.5032 56.1573 43.2332C56.1543 43.2288 56.1514 43.2247 56.1485 43.2209Z",
    fill: "url(#paint70_radial_578_447472)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2988 42.0085C54.2988 42.0085 55.024 42.4625 55.5247 43.2325C55.5247 43.2267 55.1679 42.4338 54.2988 42.0085Z",
    fill: "url(#paint71_radial_578_447472)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0781 43.228C53.0781 43.228 53.5098 43.9865 54.2407 44.4404L54.2982 44.9921L54.3385 44.429C54.3385 44.429 54.8853 44.1991 55.5241 43.228C55.5241 43.228 54.7184 44.3083 54.2867 44.3658C54.2867 44.3715 53.786 44.1761 53.0781 43.228Z",
    fill: "url(#paint72_radial_578_447472)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3037 44.446C54.3037 44.446 55.0634 44.015 55.5181 43.2853L56.0706 43.2278L55.5066 43.1876C55.5066 43.1876 55.2764 42.6417 54.3037 42.0039C54.3037 42.0039 55.3857 42.8084 55.4433 43.2393C55.449 43.2393 55.2533 43.7392 54.3037 44.446Z",
    fill: "url(#paint73_radial_578_447472)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2757 42.0039C54.2757 42.0039 53.516 42.4349 53.0613 43.1646L52.5088 43.2221L53.0728 43.2623C53.0728 43.2623 53.303 43.8082 54.2757 44.446C54.2757 44.446 53.1937 43.6415 53.1361 43.2106C53.1304 43.2106 53.326 42.7107 54.2757 42.0039Z",
    fill: "url(#paint74_radial_578_447472)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5241 43.2213C55.5241 43.2213 55.0925 42.4628 54.3616 42.0089L54.304 41.4573L54.2637 42.0204C54.2637 42.0204 53.717 42.2502 53.0781 43.2213C53.0781 43.2213 53.8839 42.1411 54.3155 42.0836C54.3155 42.0779 54.8162 42.2732 55.5241 43.2213Z",
    fill: "url(#paint75_radial_578_447472)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7529 39.5599C62.7658 39.5793 62.7658 39.6046 62.7528 39.6241C62.5186 39.9749 62.2555 40.311 61.9705 40.6253C61.955 40.6407 61.9396 40.6638 61.9164 40.6792C61.8314 40.7718 61.7387 40.8643 61.6459 40.9568C61.4295 41.1728 61.2132 41.3732 60.9736 41.5583C60.7593 41.7353 60.5379 41.8982 60.3026 42.0538C60.2831 42.0666 60.2578 42.0666 60.2385 42.0535C59.8656 41.7995 59.2826 41.3042 58.7937 40.8089C58.355 40.3645 57.9063 39.764 57.7987 39.6175C57.784 39.5976 57.7837 39.5709 57.7979 39.5506C57.8682 39.4501 58.0797 39.1495 58.2072 38.9905C58.4235 38.7207 58.6554 38.4585 58.8949 38.2117C59.0263 38.0807 59.1576 37.9573 59.2967 37.8339C59.596 37.5726 59.9097 37.333 60.238 37.1081C60.2576 37.0947 60.2834 37.0945 60.3031 37.1077C60.5465 37.2708 60.7826 37.4412 61.0045 37.6257C61.2286 37.8108 61.4373 38.0035 61.6382 38.204C62.0615 38.634 62.4331 39.0787 62.7529 39.5599Z",
    fill: "#643020"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1338 39.5893C61.9554 39.8593 61.754 40.1179 61.5353 40.3593C61.5238 40.3707 61.5123 40.388 61.495 40.3995C61.4317 40.4684 61.3626 40.5374 61.2936 40.6063C61.1324 40.7672 60.9713 40.9166 60.7929 41.0545C60.6259 41.1924 60.4533 41.3188 60.2691 41.4395C59.9929 41.2556 59.7339 41.0545 59.4864 40.8362C59.0893 40.4799 58.7382 40.0777 58.4389 39.6295C58.4274 39.6123 58.4159 39.6008 58.4102 39.5835C58.5138 39.4341 58.6173 39.2847 58.7325 39.1411C58.8936 38.94 59.0663 38.7446 59.2447 38.5607C59.3425 38.463 59.4404 38.3711 59.5439 38.2792C59.7742 38.0781 60.0159 37.8942 60.2691 37.7218C60.459 37.8482 60.6432 37.9804 60.8159 38.124C60.9828 38.2619 61.1382 38.4056 61.2878 38.555C61.6101 38.8825 61.8921 39.2215 62.1338 39.5893Z",
    fill: "url(#paint76_radial_578_447472)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1344 39.5896H60.2754V37.7394C60.6437 37.9807 60.989 38.2623 61.2998 38.5726C61.6106 38.8828 61.8926 39.2219 62.1344 39.5896Z",
    fill: "url(#paint77_radial_578_447472)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M60.275 37.7394V39.5954H58.416C58.6577 39.2276 58.9397 38.8828 59.2505 38.5726C59.5671 38.2623 59.9066 37.9807 60.275 37.7394Z",
    fill: "url(#paint78_radial_578_447472)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M60.275 39.5896V41.4456C59.5383 40.9572 58.9052 40.3251 58.416 39.5896H60.275Z",
    fill: "url(#paint79_radial_578_447472)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1344 39.5897C61.8926 39.9575 61.6106 40.3022 61.2998 40.6125C60.989 40.9228 60.6437 41.2044 60.2754 41.4457V39.5897H62.1344Z",
    fill: "url(#paint80_radial_578_447472)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1329 39.5892C61.8912 39.957 61.6091 40.3018 61.2984 40.612C60.9876 40.9223 60.6423 41.2039 60.2739 41.4452C59.9977 41.2614 59.8998 41.1981 59.6523 40.9798L60.8207 38.1412C60.9876 38.2791 61.143 38.4228 61.2926 38.5722C61.6091 38.8825 61.8912 39.2215 62.1329 39.5892Z",
    fill: "url(#paint81_radial_578_447472)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5004 40.4049C61.4371 40.4738 61.368 40.5428 61.299 40.6117C60.9882 40.922 60.6429 41.2036 60.2745 41.4449C59.9983 41.261 59.7393 41.0599 59.4918 40.8416C59.0947 40.4853 58.7436 40.0831 58.4443 39.6349C59.2213 39.8647 60.3608 40.1808 61.5004 40.4049Z",
    fill: "url(#paint82_radial_578_447472)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5356 40.3593C61.5241 40.3708 61.5126 40.388 61.4953 40.3995C61.432 40.4684 61.3629 40.5374 61.2939 40.6064C61.1327 40.7672 60.9716 40.9166 60.7932 41.0546C60.3558 40.2788 59.8723 39.348 59.832 38.986C59.8378 38.9917 60.8047 39.7904 61.5356 40.3593Z",
    fill: "url(#paint83_radial_578_447472)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2749 39.5895L58.7383 39.1471C58.8994 38.946 59.0721 38.7506 59.2505 38.5667C59.3483 38.469 59.4462 38.3771 59.5498 38.2852L60.2749 39.5895Z",
    fill: "url(#paint84_radial_578_447472)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2747 40.8137C59.7913 40.4919 59.3711 40.0782 59.0488 39.5898C59.3711 39.1071 59.7855 38.6876 60.2747 38.3658C60.7582 38.6876 61.1783 39.1013 61.5006 39.5898C61.1783 40.0782 60.7639 40.4919 60.2747 40.8137Z",
    fill: "url(#paint85_radial_578_447472)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7383 39.233C58.8995 39.0319 59.0721 38.8365 59.2505 38.6527C59.3484 38.555 59.4462 38.463 59.5498 38.3711C59.78 38.17 60.0217 37.9861 60.275 37.8137C60.4649 37.9402 60.6491 38.0723 60.8217 38.216C60.9886 38.3539 61.144 38.4975 61.2937 38.6469C61.5929 38.9457 61.8634 39.2732 62.0994 39.6238C62.1109 39.6065 62.1167 39.595 62.1282 39.5778C61.8865 39.21 61.6045 38.8653 61.2937 38.555C61.144 38.4056 60.9829 38.2619 60.8217 38.124C60.6491 37.9804 60.4649 37.8425 60.275 37.7218C60.0217 37.8884 59.78 38.0781 59.5498 38.2792C59.4462 38.3711 59.3484 38.463 59.2505 38.5607C59.0664 38.7446 58.8937 38.9342 58.7383 39.1411C58.6232 39.2847 58.5196 39.4341 58.416 39.5835C58.4275 39.6008 58.4333 39.6123 58.4448 39.6295C58.5426 39.4973 58.6405 39.3652 58.7383 39.233Z",
    fill: "url(#paint86_radial_578_447472)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5353 40.2732C61.5238 40.2847 61.5123 40.3019 61.495 40.3134C61.4317 40.3824 61.3626 40.4513 61.2936 40.5203C61.1324 40.6812 60.9713 40.8306 60.7929 40.9685C60.6259 41.1064 60.4533 41.2328 60.2691 41.3535C59.9929 41.1696 59.7339 40.9685 59.4864 40.7501C59.0893 40.3939 58.7382 39.9917 58.4389 39.5435C58.4274 39.5607 58.4159 39.5722 58.4102 39.5894C58.4217 39.6067 58.4332 39.6182 58.4389 39.6354C58.7382 40.0778 59.0893 40.4801 59.4864 40.8421C59.7281 41.0604 59.9929 41.2673 60.2691 41.4454C60.4475 41.3247 60.6259 41.1983 60.7929 41.0604C60.9655 40.9168 61.1324 40.7674 61.2936 40.6122C61.3626 40.5433 61.4259 40.4743 61.495 40.4054C61.5065 40.3939 61.518 40.3766 61.5353 40.3651C61.754 40.1238 61.9497 39.8652 62.1338 39.5952C62.1223 39.5779 62.1108 39.5664 62.1051 39.5492C61.9324 39.802 61.7425 40.0434 61.5353 40.2732Z",
    fill: "url(#paint87_radial_578_447472)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2509 38.6525C59.0725 38.8364 58.8998 39.0318 58.7386 39.2329L58.4723 39.5927C58.7642 40.0211 59.1039 40.4069 59.4864 40.75C59.7339 40.9684 59.9929 41.1695 60.2691 41.3534C60.4533 41.2327 60.6259 41.1063 60.7929 40.9684C60.9713 40.8305 61.1324 40.6811 61.2936 40.5202C61.3626 40.4512 61.4317 40.3823 61.495 40.3133C61.5068 40.3055 61.5159 40.2949 61.5242 40.2854C61.528 40.281 61.5316 40.2767 61.5353 40.2731C61.7313 40.0557 61.9118 39.828 62.0769 39.59C61.8464 39.2521 61.5837 38.936 61.294 38.6468C61.1444 38.4974 60.989 38.3537 60.8221 38.2158C60.6494 38.0722 60.4652 37.94 60.2753 37.8136C60.0221 37.986 59.7804 38.1699 59.5501 38.371C59.4466 38.4629 59.3487 38.5549 59.2509 38.6525ZM62.1251 39.5828C62.1262 39.5812 62.1273 39.5794 62.1285 39.5777C61.8868 39.2099 61.6048 38.8651 61.294 38.5549C61.1444 38.4055 60.9832 38.2618 60.8221 38.1239C60.6494 37.9803 60.4652 37.8423 60.2753 37.7217C60.0221 37.8883 59.7804 38.0779 59.5501 38.279C59.4466 38.371 59.3487 38.4629 59.2509 38.5606C59.0667 38.7445 58.894 38.9341 58.7386 39.141C58.6329 39.273 58.5368 39.4099 58.4415 39.5472C58.4406 39.5459 58.4398 39.5446 58.4389 39.5434C58.4355 39.5485 58.4321 39.5531 58.4288 39.5576C58.4211 39.568 58.4142 39.5772 58.4102 39.5893C58.4136 39.5945 58.417 39.5991 58.4203 39.6035C58.428 39.6139 58.4349 39.6232 58.4389 39.6353C58.7382 40.0777 59.0893 40.48 59.4864 40.842C59.7281 41.0603 59.9929 41.2672 60.2691 41.4453C60.4475 41.3246 60.6259 41.1982 60.7929 41.0603C60.9655 40.9167 61.1324 40.7673 61.2936 40.6121C61.3281 40.5776 61.3612 40.5432 61.3943 40.5087C61.4274 40.4742 61.4605 40.4397 61.495 40.4053C61.4986 40.4016 61.5023 40.3974 61.5061 40.393C61.5144 40.3834 61.5235 40.3729 61.5353 40.365C61.754 40.1237 61.9497 39.8651 62.1338 39.5951C62.1309 39.5907 62.128 39.5867 62.1251 39.5828Z",
    fill: "url(#paint88_radial_578_447472)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2754 38.3705C60.2754 38.3705 61.0006 38.8244 61.5013 39.5944C61.5013 39.5887 61.1444 38.7957 60.2754 38.3705Z",
    fill: "url(#paint89_radial_578_447472)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0547 39.59C59.0547 39.59 59.4863 40.3484 60.2173 40.8024L60.2748 41.354L60.3151 40.7909C60.3151 40.7909 60.8619 40.5611 61.5007 39.59C61.5007 39.59 60.6949 40.6702 60.2633 40.7277C60.2633 40.7334 59.7626 40.5381 59.0547 39.59Z",
    fill: "url(#paint90_radial_578_447472)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2803 40.808C60.2803 40.808 61.04 40.3771 61.4946 39.6473L62.0471 39.5899L61.4831 39.5497C61.4831 39.5497 61.2529 39.0038 60.2803 38.366C60.2803 38.366 61.3623 39.1704 61.4198 39.6014C61.4256 39.6014 61.2299 40.1013 60.2803 40.808Z",
    fill: "url(#paint91_radial_578_447472)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2522 38.3658C60.2522 38.3658 59.4925 38.7968 59.0379 39.5266L58.4854 39.584L59.0494 39.6242C59.0494 39.6242 59.2796 40.1701 60.2522 40.8079C60.2522 40.8079 59.1702 40.0035 59.1127 39.5725C59.1069 39.5725 59.3026 39.0726 60.2522 38.3658Z",
    fill: "url(#paint92_radial_578_447472)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5007 39.5833C61.5007 39.5833 61.069 38.8248 60.3381 38.3708L60.2806 37.8192L60.2403 38.3823C60.2403 38.3823 59.6935 38.6122 59.0547 39.5833C59.0547 39.5833 59.8604 38.503 60.2921 38.4455C60.2921 38.4398 60.7928 38.6352 61.5007 39.5833Z",
    fill: "url(#paint93_radial_578_447472)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0547 38.1991V39.2327C64.0547 41.1374 63.193 42.9093 61.8094 43.8248L51.0801 50.927C49.2838 52.123 47.0991 52.123 45.3028 50.927L34.5735 43.8248C33.1899 42.9093 32.3281 41.1522 32.3281 39.2327V38.1991C32.3281 40.1039 33.1899 41.8757 34.5735 42.7912L45.3028 49.8934C47.0991 51.0894 49.2838 51.0894 51.0801 49.8934L61.8094 42.7912C63.193 41.8757 64.0547 40.1186 64.0547 38.1991Z",
    fill: "url(#paint94_radial_578_447472)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2549 10.4794L14.6115 11.9958L17.9381 16.8653C19.0136 18.4339 20.4767 19.6591 22.2391 20.4069L25.1287 21.6328L26.6743 25.4564C26.6861 25.4856 26.6979 25.5147 26.7215 25.5731C26.9159 25.9699 27.1773 26.3227 27.5232 26.5904C27.535 26.6196 27.5964 26.6456 27.6374 26.663C27.6697 26.7009 27.7107 26.7182 27.7722 26.7443C27.907 26.8257 28.0299 26.8779 28.1939 26.9474L35.3459 29.9818L39.0498 21.2517L27.5315 16.0264L15.2549 10.4794Z",
    fill: "url(#paint95_radial_578_447472)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5023 16.0387L15.2432 10.4507L14.5998 11.9671L17.9264 16.8366C19.0019 18.4052 20.465 19.6305 22.2274 20.3783L25.1169 21.6042L27.4818 16.03L27.5023 16.0387Z",
    fill: "url(#paint96_radial_578_447472)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4394 10.5581L18.6456 15.2555C19.7211 16.8241 21.1929 18.0289 22.9553 18.7766L25.8448 20.0026L27.3904 23.8261C27.6735 24.5266 28.2045 25.0421 28.8808 25.329L35.9918 28.346L35.9484 28.4485L28.7963 25.4141C28.12 25.1272 27.5773 24.5825 27.306 23.9112L25.7603 20.0876L22.8708 18.8617C21.1289 18.1227 19.6161 16.9006 18.5697 15.3201L15.2432 10.4507L15.4394 10.5581Z",
    fill: "url(#paint97_radial_578_447472)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5704 23.5152L26.7097 25.5441C26.904 25.9409 27.1655 26.2936 27.5114 26.5612C27.5232 26.5904 27.5847 26.6165 27.6257 26.6339C27.658 26.6718 27.6989 26.6892 27.7604 26.7153L28.8906 24.0512L27.5791 23.4948L27.5704 23.5152Z",
    fill: "url(#paint98_radial_578_447472)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2549 10.4794L18.5815 15.3487C19.6571 16.9174 21.1201 18.1427 22.8825 18.8904L25.7721 20.1163L27.3177 23.9399C27.6009 24.6404 28.1318 25.1559 28.808 25.4428L35.9601 28.4771L39.0206 21.2635L15.7262 10.6793L15.2549 10.4794Z",
    fill: "url(#paint99_radial_578_447472)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9914 21.2757L15.604 10.7971L18.6574 15.2845C19.7329 16.8532 21.2047 18.058 22.9671 18.8057L25.8566 20.0316L27.4022 23.8552C27.6853 24.5557 28.2163 25.0712 28.8926 25.3581L36.0037 28.375L35.9602 28.4775L28.8081 25.4431C28.1318 25.1562 27.5891 24.6116 27.3178 23.9403L25.7722 20.1167L22.8826 18.8908C21.1407 18.1517 19.628 16.9295 18.5816 15.3491L16.9887 13.0047L15.2909 10.7368L14.6203 11.9757L15.2637 10.4592L38.9914 21.2757Z",
    fill: "url(#paint100_radial_578_447472)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2871 29.319C38.2783 29.3398 38.2783 29.3398 38.2871 29.319C38.2871 29.319 38.2991 29.3487 38.2871 29.319Z",
    fill: "url(#paint101_radial_578_447472)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5813 12.9177L19.0064 14.9732C19.8702 16.1861 21.0284 17.1611 22.384 17.7846L37.5533 24.6072L38.5966 22.148C33.438 19.8869 17.5459 12.8301 17.5813 12.9177Z",
    fill: "url(#paint102_radial_578_447472)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M26.418 19.9069L27.5985 22.9952L36.6154 26.8208L37.4588 24.8329L26.418 19.9069Z",
    fill: "url(#paint103_radial_578_447472)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2549 10.4794L14.6115 11.9958L17.9381 16.8653C19.0136 18.4339 20.4767 19.6591 22.2391 20.4069L25.1287 21.6328L26.6743 25.4564C26.6861 25.4856 26.6979 25.5147 26.7215 25.5731C26.9159 25.9699 27.1773 26.3227 27.5232 26.5904C27.535 26.6196 27.5964 26.6456 27.6374 26.663C27.6697 26.7009 27.7107 26.7182 27.7722 26.7443C27.907 26.8257 28.0299 26.8779 28.1939 26.9474L35.3459 29.9818L39.0498 21.2517L27.5315 16.0264L15.2549 10.4794Z",
    fill: "url(#paint104_radial_578_447472)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2549 10.4794L14.6115 11.9958L17.9381 16.8653C19.0136 18.4339 20.4767 19.6591 22.2391 20.4069L25.1287 21.6328L26.6743 25.4564C26.6861 25.4856 26.6979 25.5147 26.7215 25.5731C26.9159 25.9699 27.1773 26.3227 27.5232 26.5904C27.535 26.6196 27.5964 26.6456 27.6374 26.663C27.6697 26.7009 27.7107 26.7182 27.7722 26.7443C27.907 26.8257 28.0299 26.8779 28.1939 26.9474L35.3459 29.9818L39.0498 21.2517L27.5315 16.0264L15.2549 10.4794Z",
    fill: "url(#paint105_radial_578_447472)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9914 21.2757L15.604 10.7971L18.6574 15.2845C19.7329 16.8532 21.2047 18.058 22.9671 18.8057L25.8566 20.0316L27.4022 23.8552C27.6853 24.5557 28.2163 25.0712 28.8926 25.3581L36.0037 28.375L35.9602 28.4775L28.8081 25.4431C28.1318 25.1562 27.5891 24.6116 27.3178 23.9403L25.7722 20.1167L22.8826 18.8908C21.1407 18.1517 19.628 16.9295 18.5816 15.3491L16.9887 13.0047L15.2909 10.7368L14.6203 11.9757L15.2637 10.4592L38.9914 21.2757Z",
    fill: "url(#paint106_radial_578_447472)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M79.248 10.9604L79.8914 12.4769L76.5649 17.3463C75.4893 18.915 74.0262 20.1402 72.2638 20.8879L69.3742 22.1139L67.8286 25.9375C67.8168 25.9666 67.805 25.9958 67.7814 26.0542C67.5871 26.451 67.3256 26.8038 66.9797 27.0715C66.9679 27.1007 66.9066 27.1267 66.8656 27.1441C66.8333 27.182 66.7922 27.1993 66.7307 27.2254C66.596 27.3068 66.473 27.359 66.3091 27.4285L59.157 30.4629L55.4531 21.7328L66.9715 16.5075L79.248 10.9604Z",
    fill: "url(#paint107_radial_578_447472)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0006 16.5199L79.2598 10.9319L79.9031 12.4484L76.5766 17.3178C75.501 18.8864 74.038 20.1117 72.2756 20.8595L69.386 22.0854L67.0211 16.5112L67.0006 16.5199Z",
    fill: "url(#paint108_radial_578_447472)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0635 11.0393L75.8573 15.7367C74.7818 17.3053 73.31 18.5101 71.5476 19.2578L68.6581 20.4838L67.1126 24.3073C66.8294 25.0078 66.2984 25.5233 65.6221 25.8102L58.5111 28.8272L58.5546 28.9297L65.7066 25.8953C66.3829 25.6084 66.9256 25.0637 67.197 24.3924L68.7426 20.5688L71.6321 19.3429C73.374 18.6039 74.8868 17.3818 75.9332 15.8013L79.2598 10.9319L79.0635 11.0393Z",
    fill: "url(#paint109_radial_578_447472)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9325 23.9964L67.7933 26.0253C67.5989 26.4221 67.3374 26.7748 66.9915 27.0424C66.9797 27.0716 66.9182 27.0977 66.8773 27.1151C66.845 27.153 66.8041 27.1704 66.7426 27.1965L65.6123 24.5324L66.9238 23.976L66.9325 23.9964Z",
    fill: "url(#paint110_radial_578_447472)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M79.248 10.9604L75.9214 15.8298C74.8459 17.3984 73.3828 18.6237 71.6204 19.3715L68.7309 20.5974L67.1852 24.421C66.9021 25.1215 66.3712 25.6369 65.6949 25.9239L58.5428 28.9582L55.4824 21.7446L78.7767 11.1604L79.248 10.9604Z",
    fill: "url(#paint111_radial_578_447472)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5115 21.7569L78.899 11.2783L75.8455 15.7657C74.77 17.3344 73.2982 18.5392 71.5358 19.2869L68.6464 20.5128L67.1008 24.3364C66.8176 25.0369 66.2866 25.5524 65.6103 25.8393L58.4993 28.8562L58.5427 28.9587L65.6948 25.9243C66.3711 25.6374 66.9138 25.0928 67.1851 24.4215L68.7308 20.5979L71.6203 19.372C73.3622 18.6329 74.875 17.4107 75.9213 15.8303L77.5142 13.4859L79.212 11.218L79.8826 12.4569L79.2393 10.9404L55.5115 21.7569Z",
    fill: "url(#paint112_radial_578_447472)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2158 29.8002C56.2247 29.821 56.2247 29.821 56.2158 29.8002C56.2158 29.8002 56.2038 29.8299 56.2158 29.8002Z",
    fill: "url(#paint113_radial_578_447472)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9217 13.3989L75.4965 15.4544C74.6327 16.6673 73.4746 17.6423 72.1189 18.2658L56.9497 25.0884L55.9063 22.6292C61.065 20.3681 76.9571 13.3113 76.9217 13.3989Z",
    fill: "url(#paint114_radial_578_447472)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M68.085 20.3881L66.9044 23.4764L57.8875 27.302L57.0441 25.3141L68.085 20.3881Z",
    fill: "url(#paint115_radial_578_447472)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M79.248 10.9604L79.8914 12.4769L76.5649 17.3463C75.4893 18.915 74.0262 20.1402 72.2638 20.8879L69.3742 22.1139L67.8286 25.9375C67.8168 25.9666 67.805 25.9958 67.7814 26.0542C67.5871 26.451 67.3256 26.8038 66.9797 27.0715C66.9679 27.1007 66.9066 27.1267 66.8656 27.1441C66.8333 27.182 66.7922 27.1993 66.7307 27.2254C66.596 27.3068 66.473 27.359 66.3091 27.4285L59.157 30.4629L55.4531 21.7328L66.9715 16.5075L79.248 10.9604Z",
    fill: "url(#paint116_radial_578_447472)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M79.248 10.9604L79.8914 12.4769L76.5649 17.3463C75.4893 18.915 74.0262 20.1402 72.2638 20.8879L69.3742 22.1139L67.8286 25.9375C67.8168 25.9666 67.805 25.9958 67.7814 26.0542C67.5871 26.451 67.3256 26.8038 66.9797 27.0715C66.9679 27.1007 66.9066 27.1267 66.8656 27.1441C66.8333 27.182 66.7922 27.1993 66.7307 27.2254C66.596 27.3068 66.473 27.359 66.3091 27.4285L59.157 30.4629L55.4531 21.7328L66.9715 16.5075L79.248 10.9604Z",
    fill: "url(#paint117_radial_578_447472)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5115 21.7569L78.899 11.2783L75.8455 15.7657C74.77 17.3344 73.2982 18.5392 71.5358 19.2869L68.6464 20.5128L67.1008 24.3364C66.8176 25.0369 66.2866 25.5524 65.6103 25.8393L58.4993 28.8562L58.5427 28.9587L65.6948 25.9243C66.3711 25.6374 66.9138 25.0928 67.1851 24.4215L68.7308 20.5979L71.6203 19.372C73.3622 18.6329 74.875 17.4107 75.9213 15.8303L77.5142 13.4859L79.212 11.218L79.8826 12.4569L79.2393 10.9404L55.5115 21.7569Z",
    fill: "url(#paint118_radial_578_447472)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8037 18.1135L15.4568 19.4082L18.688 22.9557C19.7321 24.0981 21.0496 24.9199 22.5543 25.323L25.0213 25.9841L26.6992 28.8903C26.712 28.9124 26.7248 28.9346 26.7504 28.979C26.9519 29.2767 27.2025 29.5315 27.5115 29.708C27.5243 29.7302 27.5767 29.7443 27.6117 29.7536C27.642 29.7805 27.677 29.7898 27.7295 29.8039C27.8473 29.8542 27.9523 29.8824 28.0923 29.9199L34.1985 31.556L36.1956 24.1026L26.3234 21.1948L15.8037 18.1135Z",
    fill: "url(#paint119_radial_578_447472)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3013 21.2081L15.791 18.0918L15.4441 19.3865L18.6753 22.934C19.7194 24.0764 21.0369 24.8982 22.5416 25.3014L25.0086 25.9624L26.2838 21.2034L26.3013 21.2081Z",
    fill: "url(#paint120_radial_578_447472)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9613 18.1562L19.0761 21.5786C20.1201 22.721 21.4423 23.5253 22.947 23.9285L25.414 24.5895L27.0918 27.4957C27.3992 28.0281 27.8854 28.3834 28.4628 28.5382L34.534 30.1649L34.5105 30.2524L28.4043 28.6162C27.8269 28.4615 27.328 28.0841 27.0334 27.5738L25.3555 24.6676L22.8885 24.0066C21.4013 23.6081 20.0442 22.7945 19.0223 21.6393L15.791 18.0918L15.9613 18.1562Z",
    fill: "url(#paint121_radial_578_447472)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2014 27.2247L26.7372 28.9569C26.9387 29.2547 27.1893 29.5093 27.4983 29.6859C27.5111 29.7081 27.5636 29.7221 27.5986 29.7315C27.6289 29.7584 27.6639 29.7678 27.7163 29.7818L28.3258 27.5073L27.2061 27.2073L27.2014 27.2247Z",
    fill: "url(#paint122_radial_578_447472)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8037 18.1135L19.035 21.6609C20.0791 22.8033 21.3965 23.6251 22.9012 24.0283L25.3682 24.6894L27.0461 27.5955C27.3535 28.128 27.8396 28.4833 28.417 28.638L34.5232 30.2741L36.1734 24.1154L16.2061 18.2213L15.8037 18.1135Z",
    fill: "url(#paint123_radial_578_447472)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1504 24.1285L16.12 18.3301L19.088 21.6006C20.132 22.743 21.4542 23.5473 22.9589 23.9505L25.4258 24.6115L27.1037 27.5177C27.4111 28.0502 27.8973 28.4055 28.4747 28.5602L34.5459 30.1869L34.5224 30.2744L28.4162 28.6383C27.8388 28.4836 27.3399 28.1061 27.0453 27.5958L25.3675 24.6897L22.9004 24.0286C21.4133 23.6301 20.0561 22.8164 19.0342 21.6612L17.4855 19.9523L15.861 18.3169L15.4607 19.391L15.8076 18.0963L36.1504 24.1285Z",
    fill: "url(#paint124_radial_578_447472)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4932 30.6893C36.4884 30.7071 36.4884 30.7071 36.4932 30.6893C36.4932 30.6893 36.5062 30.7119 36.4932 30.6893Z",
    fill: "url(#paint125_radial_578_447472)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9541 19.8151L19.335 21.3103C20.1682 22.1898 21.2117 22.8445 22.3745 23.1936L35.3694 26.9755L35.9319 24.876C31.5194 23.6374 17.9157 19.7485 17.9541 19.8151Z",
    fill: "url(#paint126_radial_578_447472)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8643 24.4475L27.1648 26.8025L34.8632 28.8653L35.318 27.1681L25.8643 24.4475Z",
    fill: "url(#paint127_radial_578_447472)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8037 18.1135L15.4568 19.4082L18.688 22.9557C19.7321 24.0981 21.0496 24.9199 22.5543 25.323L25.0213 25.9841L26.6992 28.8903C26.712 28.9124 26.7248 28.9346 26.7504 28.979C26.9519 29.2767 27.2025 29.5315 27.5115 29.708C27.5243 29.7302 27.5767 29.7443 27.6117 29.7536C27.642 29.7805 27.677 29.7898 27.7295 29.8039C27.8473 29.8542 27.9523 29.8824 28.0923 29.9199L34.1985 31.556L36.1956 24.1026L26.3234 21.1948L15.8037 18.1135Z",
    fill: "url(#paint128_radial_578_447472)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8037 18.1135L15.4568 19.4082L18.688 22.9557C19.7321 24.0981 21.0496 24.9199 22.5543 25.323L25.0213 25.9841L26.6992 28.8903C26.712 28.9124 26.7248 28.9346 26.7504 28.979C26.9519 29.2767 27.2025 29.5315 27.5115 29.708C27.5243 29.7302 27.5767 29.7443 27.6117 29.7536C27.642 29.7805 27.677 29.7898 27.7295 29.8039C27.8473 29.8542 27.9523 29.8824 28.0923 29.9199L34.1985 31.556L36.1956 24.1026L26.3234 21.1948L15.8037 18.1135Z",
    fill: "url(#paint129_radial_578_447472)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1504 24.1285L16.12 18.3301L19.088 21.6006C20.132 22.743 21.4542 23.5473 22.9589 23.9505L25.4258 24.6115L27.1037 27.5177C27.4111 28.0502 27.8973 28.4055 28.4747 28.5602L34.5459 30.1869L34.5224 30.2744L28.4162 28.6383C27.8388 28.4836 27.3399 28.1061 27.0453 27.5958L25.3675 24.6897L22.9004 24.0286C21.4133 23.6301 20.0561 22.8164 19.0342 21.6612L17.4855 19.9523L15.861 18.3169L15.4607 19.391L15.8076 18.0963L36.1504 24.1285Z",
    fill: "url(#paint130_radial_578_447472)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M79.918 18.1135L80.2649 19.4082L77.0336 22.9557C75.9896 24.0981 74.672 24.9199 73.1674 25.323L70.7004 25.9841L69.0225 28.8903C69.0097 28.9124 68.9969 28.9346 68.9712 28.979C68.7697 29.2767 68.5192 29.5315 68.2102 29.708C68.1974 29.7302 68.145 29.7443 68.11 29.7536C68.0797 29.7805 68.0446 29.7898 67.9921 29.8039C67.8744 29.8542 67.7694 29.8824 67.6294 29.9199L61.5232 31.556L59.526 24.1026L69.3983 21.1948L79.918 18.1135Z",
    fill: "url(#paint131_radial_578_447472)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4204 21.2081L79.9307 18.0918L80.2776 19.3865L77.0463 22.934C76.0023 24.0764 74.6848 24.8982 73.1801 25.3014L70.7131 25.9624L69.4379 21.2034L69.4204 21.2081Z",
    fill: "url(#paint132_radial_578_447472)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7604 18.1562L76.6456 21.5786C75.6015 22.721 74.2794 23.5253 72.7747 23.9285L70.3077 24.5895L68.6299 27.4957C68.3225 28.0281 67.8363 28.3834 67.2589 28.5382L61.1877 30.1649L61.2112 30.2524L67.3174 28.6162C67.8948 28.4615 68.3937 28.0841 68.6882 27.5738L70.3661 24.6676L72.8331 24.0066C74.3203 23.6081 75.6775 22.7945 76.6994 21.6393L79.9307 18.0918L79.7604 18.1562Z",
    fill: "url(#paint133_radial_578_447472)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5203 27.2247L68.9844 28.9569C68.7829 29.2547 68.5324 29.5093 68.2234 29.6859C68.2106 29.7081 68.1581 29.7221 68.1231 29.7315C68.0928 29.7584 68.0578 29.7678 68.0053 29.7818L67.3959 27.5073L68.5156 27.2073L68.5203 27.2247Z",
    fill: "url(#paint134_radial_578_447472)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M79.918 18.1135L76.6867 21.6609C75.6426 22.8033 74.3251 23.6251 72.8204 24.0283L70.3534 24.6894L68.6756 27.5955C68.3682 28.128 67.8821 28.4833 67.3047 28.638L61.1985 30.2741L59.5482 24.1154L79.5156 18.2213L79.918 18.1135Z",
    fill: "url(#paint135_radial_578_447472)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5712 24.1285L79.6017 18.3301L76.6337 21.6006C75.5896 22.743 74.2675 23.5473 72.7628 23.9505L70.2958 24.6115L68.618 27.5177C68.3106 28.0502 67.8244 28.4055 67.247 28.5602L61.1758 30.1869L61.1993 30.2744L67.3055 28.6383C67.8829 28.4836 68.3817 28.1061 68.6763 27.5958L70.3542 24.6897L72.8212 24.0286C74.3084 23.6301 75.6656 22.8164 76.6875 21.6612L78.2362 19.9523L79.8607 18.3169L80.261 19.391L79.9141 18.0963L59.5712 24.1285Z",
    fill: "url(#paint136_radial_578_447472)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2285 30.6893C59.2333 30.7071 59.2333 30.7071 59.2285 30.6893C59.2285 30.6893 59.2155 30.7119 59.2285 30.6893Z",
    fill: "url(#paint137_radial_578_447472)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7676 19.8151L76.3867 21.3103C75.5535 22.1898 74.51 22.8445 73.3471 23.1936L60.3523 26.9755L59.7897 24.876C64.2023 23.6374 77.806 19.7485 77.7676 19.8151Z",
    fill: "url(#paint138_radial_578_447472)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8564 24.4476L68.5559 26.8027L60.8575 28.8654L60.4028 27.1683L69.8564 24.4476Z",
    fill: "url(#paint139_radial_578_447472)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M79.918 18.1135L80.2649 19.4082L77.0336 22.9557C75.9896 24.0981 74.672 24.9199 73.1674 25.323L70.7004 25.9841L69.0225 28.8903C69.0097 28.9124 68.9969 28.9346 68.9712 28.979C68.7697 29.2767 68.5192 29.5315 68.2102 29.708C68.1974 29.7302 68.145 29.7443 68.11 29.7536C68.0797 29.7805 68.0446 29.7898 67.9921 29.8039C67.8744 29.8542 67.7694 29.8824 67.6294 29.9199L61.5232 31.556L59.526 24.1026L69.3983 21.1948L79.918 18.1135Z",
    fill: "url(#paint140_radial_578_447472)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M79.918 18.1135L80.2649 19.4082L77.0336 22.9557C75.9896 24.0981 74.672 24.9199 73.1674 25.323L70.7004 25.9841L69.0225 28.8903C69.0097 28.9124 68.9969 28.9346 68.9712 28.979C68.7697 29.2767 68.5192 29.5315 68.2102 29.708C68.1974 29.7302 68.145 29.7443 68.11 29.7536C68.0797 29.7805 68.0446 29.7898 67.9921 29.8039C67.8744 29.8542 67.7694 29.8824 67.6294 29.9199L61.5232 31.556L59.526 24.1026L69.3983 21.1948L79.918 18.1135Z",
    fill: "url(#paint141_radial_578_447472)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5712 24.1285L79.6017 18.3301L76.6337 21.6006C75.5896 22.743 74.2675 23.5473 72.7628 23.9505L70.2958 24.6115L68.618 27.5177C68.3106 28.0502 67.8244 28.4055 67.247 28.5602L61.1758 30.1869L61.1993 30.2744L67.3055 28.6383C67.8829 28.4836 68.3817 28.1061 68.6763 27.5958L70.3542 24.6897L72.8212 24.0286C74.3084 23.6301 75.6656 22.8164 76.6875 21.6612L78.2362 19.9523L79.8607 18.3169L80.261 19.391L79.9141 18.0963L59.5712 24.1285Z",
    fill: "url(#paint142_radial_578_447472)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7139 25.2814V26.3583L23.9593 28.4395C25.0071 29.109 26.2005 29.4727 27.4521 29.4727H29.5042L31.4107 31.3793C31.4252 31.3938 31.4398 31.4084 31.4689 31.4375C31.6872 31.6267 31.9346 31.7722 32.2111 31.845C32.2257 31.8596 32.2693 31.8596 32.2984 31.8596C32.3275 31.8741 32.3566 31.8741 32.4003 31.8741C32.5022 31.8886 32.5895 31.8886 32.7059 31.8886H37.7851V25.6888L29.5187 25.4851L20.7139 25.2814Z",
    fill: "url(#paint143_radial_578_447472)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5041 25.5L20.6992 25.2671V26.344L23.9446 28.4252C24.9925 29.0947 26.1859 29.4585 27.4375 29.4585H29.4895V25.5H29.5041Z",
    fill: "url(#paint144_radial_578_447472)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8448 25.2817L23.9738 27.29C25.0216 27.9595 26.215 28.3088 27.4666 28.3088H29.5186L31.4251 30.2153C31.7744 30.5646 32.2256 30.7392 32.7058 30.7392H37.7559V30.812H32.6767C32.1964 30.812 31.7308 30.6228 31.396 30.288L29.4895 28.3815H27.4375C26.2004 28.3815 24.9779 28.0323 23.9446 27.3483L20.6992 25.2671L20.8448 25.2817Z",
    fill: "url(#paint145_radial_578_447472)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4541 29.9823V31.4231C31.6724 31.6123 31.9198 31.7578 32.1963 31.8306C32.2109 31.8451 32.2546 31.8452 32.2837 31.8452C32.3128 31.8597 32.3419 31.8597 32.3855 31.8597V29.9678H31.4541V29.9823Z",
    fill: "url(#paint146_radial_578_447472)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7139 25.2814L23.9593 27.3625C25.0071 28.032 26.2005 28.3958 27.4521 28.3958H29.5042L31.4107 30.3023C31.76 30.6516 32.2111 30.8263 32.6914 30.8263H37.7705V25.7034L21.0486 25.2814H20.7139Z",
    fill: "url(#paint147_radial_578_447472)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7559 25.7183L21.0049 25.3836L23.9884 27.3046C25.0363 27.974 26.2296 28.3233 27.4812 28.3233H29.5332L31.4397 30.2298C31.789 30.5791 32.2402 30.7538 32.7205 30.7538H37.7705V30.8265H32.6914C32.2111 30.8265 31.7454 30.6373 31.4107 30.3026L29.5042 28.3961H27.4521C26.2151 28.3961 24.9926 28.0468 23.9593 27.3628L22.402 26.3586L20.8011 25.4272L20.7139 26.344V25.2671L37.7559 25.7183Z",
    fill: "url(#paint148_radial_578_447472)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3857 30.7388C39.3857 30.7537 39.3857 30.7537 39.3857 30.7388C39.3857 30.7388 39.4007 30.7537 39.3857 30.7388Z",
    fill: "url(#paint149_radial_578_447472)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7365 26.1547L24.119 27.0279C24.9486 27.5373 25.8945 27.8284 26.8696 27.8575L37.7411 28.0903V26.3439C34.0591 26.3002 22.6928 26.111 22.7365 26.1547Z",
    fill: "url(#paint150_radial_578_447472)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8389 28.1047L31.3379 29.662H37.7415V28.2503L29.8389 28.1047Z",
    fill: "url(#paint151_radial_578_447472)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7139 25.2814V26.3583L23.9593 28.4395C25.0071 29.109 26.2005 29.4727 27.4521 29.4727H29.5042L31.4107 31.3793C31.4252 31.3938 31.4398 31.4084 31.4689 31.4375C31.6872 31.6267 31.9346 31.7722 32.2111 31.845C32.2257 31.8596 32.2693 31.8596 32.2984 31.8596C32.3275 31.8741 32.3566 31.8741 32.4003 31.8741C32.5022 31.8886 32.5895 31.8886 32.7059 31.8886H37.7851V25.6888L29.5187 25.4851L20.7139 25.2814Z",
    fill: "url(#paint152_radial_578_447472)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7139 25.2814V26.3583L23.9593 28.4395C25.0071 29.109 26.2005 29.4727 27.4521 29.4727H29.5042L31.4107 31.3793C31.4252 31.3938 31.4398 31.4084 31.4689 31.4375C31.6872 31.6267 31.9346 31.7722 32.2111 31.845C32.2257 31.8596 32.2693 31.8596 32.2984 31.8596C32.3275 31.8741 32.3566 31.8741 32.4003 31.8741C32.5022 31.8886 32.5895 31.8886 32.7059 31.8886H37.7851V25.6888L29.5187 25.4851L20.7139 25.2814Z",
    fill: "url(#paint153_radial_578_447472)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7559 25.7183L21.0049 25.3836L23.9884 27.3046C25.0363 27.974 26.2296 28.3233 27.4812 28.3233H29.5332L31.4397 30.2298C31.789 30.5791 32.2402 30.7538 32.7205 30.7538H37.7705V30.8265H32.6914C32.2111 30.8265 31.7454 30.6373 31.4107 30.3026L29.5042 28.3961H27.4521C26.2151 28.3961 24.9926 28.0468 23.9593 27.3628L22.402 26.3586L20.8011 25.4272L20.7139 26.344V25.2671L37.7559 25.7183Z",
    fill: "url(#paint154_radial_578_447472)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0763 25.281V26.3579L72.8308 28.4391C71.7829 29.1086 70.5895 29.4724 69.3379 29.4724H67.3005L65.394 31.3789C65.3794 31.3935 65.3648 31.408 65.3357 31.4371C65.1174 31.6263 64.8701 31.7719 64.5936 31.8446C64.579 31.8592 64.5353 31.8592 64.5062 31.8592C64.4771 31.8738 64.448 31.8737 64.4043 31.8737C64.3024 31.8883 64.2151 31.8883 64.0987 31.8883H59.0195V25.6885L67.286 25.4847L76.0763 25.281Z",
    fill: "url(#paint155_radial_578_447472)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2998 25.4997L76.1047 25.2668V26.3438L72.8593 28.425C71.8114 29.0944 70.618 29.4583 69.3664 29.4583H67.3144V25.4997H67.2998Z",
    fill: "url(#paint156_radial_578_447472)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9444 25.2814L72.8154 27.2898C71.7675 27.9592 70.5741 28.3085 69.3225 28.3085H67.2705L65.364 30.215C65.0147 30.5643 64.5636 30.739 64.0833 30.739H59.0332V30.8117H64.1124C64.5926 30.8117 65.0584 30.6225 65.3931 30.2878L67.2996 28.3813H69.3516C70.5887 28.3813 71.8112 28.032 72.8445 27.348L76.0899 25.2668L75.9444 25.2814Z",
    fill: "url(#paint157_radial_578_447472)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3347 29.982V31.4229C65.1164 31.6121 64.8691 31.7576 64.5926 31.8303C64.578 31.8449 64.5343 31.8449 64.5052 31.8449C64.4761 31.8595 64.447 31.8595 64.4033 31.8595V29.9675H65.3347V29.982Z",
    fill: "url(#paint158_radial_578_447472)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0754 25.281L72.8299 27.3621C71.782 28.0316 70.5886 28.3954 69.337 28.3954H67.2996L65.3931 30.302C65.0438 30.6512 64.5926 30.8259 64.1124 30.8259H59.0332V25.703L75.7551 25.281H76.0754Z",
    fill: "url(#paint159_radial_578_447472)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0341 25.718L75.7852 25.3833L72.8017 27.3043C71.7539 27.9738 70.5605 28.3231 69.3089 28.3231H67.2568L65.3503 30.2296C65.001 30.5789 64.5499 30.7535 64.0696 30.7535H59.0195V30.8263H64.0987C64.579 30.8263 65.0447 30.6371 65.3794 30.3024L67.286 28.3958H69.3379C70.575 28.3958 71.7975 28.0465 72.8308 27.3625L74.388 26.3584L75.9889 25.4269L76.0763 26.3438V25.2668L59.0341 25.718Z",
    fill: "url(#paint160_radial_578_447472)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0525 26.1546L72.6699 27.0278C71.8404 27.5371 70.8943 27.8282 69.9193 27.8574L59.0479 28.0902V26.3437C62.7299 26.3001 74.0962 26.1109 74.0525 26.1546Z",
    fill: "url(#paint161_radial_578_447472)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9649 28.1046L65.466 29.6619H59.0479V28.2501L66.9649 28.1046Z",
    fill: "url(#paint162_radial_578_447472)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0763 25.281V26.3579L72.8308 28.4391C71.7829 29.1086 70.5895 29.4724 69.3379 29.4724H67.3005L65.394 31.3789C65.3794 31.3935 65.3648 31.408 65.3357 31.4371C65.1174 31.6263 64.8701 31.7719 64.5936 31.8446C64.579 31.8592 64.5353 31.8592 64.5062 31.8592C64.4771 31.8738 64.448 31.8737 64.4043 31.8737C64.3024 31.8883 64.2151 31.8883 64.0987 31.8883H59.0195V25.6885L67.286 25.4847L76.0763 25.281Z",
    fill: "url(#paint163_radial_578_447472)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0341 25.718L75.7852 25.3833L72.8017 27.3043C71.7539 27.9738 70.5605 28.3231 69.3089 28.3231H67.2568L65.3503 30.2296C65.001 30.5789 64.5499 30.7535 64.0696 30.7535H59.0195V30.8263H64.0987C64.579 30.8263 65.0447 30.6371 65.3794 30.3024L67.286 28.3958H69.3379C70.575 28.3958 71.7975 28.0465 72.8308 27.3625L74.388 26.3584L75.9889 25.4269L76.0763 26.3438V25.2668L59.0341 25.718Z",
    fill: "url(#paint164_radial_578_447472)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6297 30.9902C32.6297 30.9902 27.0985 27.0761 26.731 17.1897C26.7126 16.62 27.172 16.1422 27.7417 16.1422H32.6297V30.9902Z",
    fill: "url(#paint165_radial_578_447472)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6295 16.1243V29.3552C32.6295 29.3552 32.6112 29.3552 32.6112 29.3368C32.5928 29.3184 32.5928 29.3185 32.5744 29.3185C32.5009 29.2634 32.3907 29.1899 32.2069 29.0428C32.1701 29.0245 32.1334 28.9877 32.0782 28.951L32.0599 28.9326C32.0232 28.8958 31.968 28.859 31.9129 28.8039C31.8577 28.7671 31.8026 28.7121 31.7475 28.6753C31.7291 28.6569 31.6924 28.6201 31.674 28.6017C31.6189 28.5466 31.5637 28.4915 31.4902 28.4364C31.4535 28.3996 31.4167 28.3629 31.3616 28.3078C31.3064 28.2527 31.2513 28.2159 31.2146 28.1607C31.1227 28.0688 31.0124 27.9586 30.9206 27.8484C30.8471 27.7749 30.7919 27.7013 30.7184 27.6094C30.6816 27.5727 30.6449 27.536 30.6081 27.4809C30.5346 27.4074 30.4612 27.3154 30.3877 27.2235C30.3509 27.1868 30.3141 27.1317 30.2774 27.0949C30.2039 27.0031 30.112 26.9112 30.0385 26.8009C29.965 26.709 29.9099 26.6171 29.818 26.5069C29.7812 26.4517 29.7445 26.3966 29.7077 26.3415C29.671 26.2864 29.6342 26.2313 29.5974 26.1761C29.5239 26.0659 29.4505 25.9556 29.377 25.8453C29.3035 25.7167 29.2299 25.6064 29.1564 25.4962C29.1197 25.4227 29.083 25.3492 29.0278 25.2757C29.0095 25.2206 28.9543 25.1654 28.936 25.1102C28.8992 25.0367 28.8624 24.9816 28.8257 24.9265C28.7522 24.7979 28.6786 24.6509 28.6051 24.5223C28.5684 24.4488 28.5316 24.3936 28.4949 24.3201C28.4581 24.2466 28.4214 24.1731 28.3847 24.0996C28.3479 24.026 28.3111 23.9526 28.2744 23.8791C28.1641 23.6586 28.0722 23.438 27.9804 23.1991C27.962 23.1256 27.9252 23.0522 27.9069 22.9787C27.8701 22.8684 27.8333 22.7765 27.7782 22.6662C27.7598 22.5927 27.7415 22.5376 27.7047 22.4825C27.6312 22.262 27.5577 22.0414 27.4842 21.8393C27.4658 21.7658 27.4474 21.6923 27.4107 21.6188C27.3923 21.5452 27.3739 21.4718 27.3372 21.3799C27.3188 21.3064 27.3005 21.2329 27.2821 21.141C27.2453 20.9757 27.2086 20.8102 27.1534 20.6448C27.135 20.5713 27.135 20.5162 27.1166 20.4243C27.0983 20.3324 27.0799 20.2222 27.0431 20.1303C27.0248 20.0201 27.0064 19.8914 26.9697 19.7995C26.9329 19.5606 26.8961 19.3033 26.841 19.0461C26.8226 18.9174 26.8043 18.7889 26.7859 18.6602C26.7675 18.5316 26.7675 18.3846 26.7491 18.2743C26.7307 17.9987 26.694 17.7231 26.6756 17.4658C26.6756 17.3923 26.6572 17.3003 26.6572 17.2268C26.6572 17.2085 26.6572 17.2085 26.6572 17.1901V17.1718C26.6572 16.988 26.7124 16.8042 26.8043 16.6572C26.9881 16.3631 27.3004 16.1611 27.6679 16.1611L32.6295 16.1243Z",
    fill: "url(#paint166_radial_578_447472)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6295 29.1716V29.3738C32.6295 29.3738 32.6112 29.3737 32.6112 29.3554C32.5928 29.337 32.5928 29.337 32.5744 29.337C32.5009 29.2818 32.3907 29.2083 32.2069 29.0613C32.1701 29.043 32.1334 29.0062 32.0782 28.9695L32.0599 28.9511C32.0232 28.9144 31.968 28.8776 31.9129 28.8225C31.8577 28.7857 31.8026 28.7306 31.7475 28.6938C31.7291 28.6754 31.6924 28.6387 31.674 28.6203C31.6189 28.5652 31.5637 28.5101 31.4902 28.455C31.4535 28.4182 31.4167 28.3814 31.3616 28.3263C31.3064 28.2712 31.2513 28.2344 31.2146 28.1793C31.1227 28.0874 31.0124 27.9771 30.9206 27.8669C30.8471 27.7934 30.7919 27.7199 30.7184 27.628C30.6816 27.5913 30.6449 27.5545 30.6081 27.4993C30.5346 27.4258 30.4612 27.334 30.3877 27.2421C30.3509 27.2053 30.3141 27.1503 30.2774 27.1135C30.2039 27.0216 30.112 26.9297 30.0385 26.8195C29.965 26.7276 29.9099 26.6357 29.818 26.5254C29.7812 26.4703 29.7445 26.4152 29.7077 26.3601C29.671 26.3049 29.6342 26.2498 29.5974 26.1947C29.5239 26.0844 29.4505 25.9741 29.377 25.8639C29.3035 25.7352 29.2299 25.625 29.1564 25.5147C29.1197 25.4412 29.083 25.3677 29.0278 25.2942C29.0095 25.2391 28.9543 25.184 28.936 25.1288C28.8992 25.0553 28.8624 25.0002 28.8257 24.9451C28.7522 24.8164 28.6786 24.6695 28.6051 24.5408C28.5684 24.4673 28.5316 24.4122 28.4949 24.3387C28.4581 24.2652 28.4214 24.1916 28.3847 24.1181C28.3479 24.0446 28.3111 23.9712 28.2744 23.8977C28.1641 23.6772 28.0722 23.4566 27.9804 23.2177C27.962 23.1442 27.9252 23.0707 27.9069 22.9972C27.8701 22.8869 27.8333 22.7951 27.7782 22.6848C27.7598 22.6113 27.7415 22.5562 27.7047 22.5011C27.6312 22.2805 27.5577 22.06 27.4842 21.8579C27.4658 21.7844 27.4474 21.7108 27.4107 21.6373C27.3923 21.5638 27.3739 21.4904 27.3372 21.3985C27.3188 21.325 27.3005 21.2514 27.2821 21.1595C27.2453 20.9941 27.2086 20.8288 27.1534 20.6634C27.135 20.5899 27.135 20.5348 27.1166 20.4429C27.0983 20.351 27.0799 20.2407 27.0431 20.1488C27.0248 20.0386 27.0064 19.91 26.9697 19.8181C26.9329 19.5792 26.8961 19.3219 26.841 19.0647C26.8226 18.936 26.8043 18.8074 26.7859 18.6787C26.7675 18.5501 26.7675 18.4032 26.7491 18.2929C26.7307 18.0173 26.694 17.7415 26.6756 17.4843C26.6756 17.3924 26.6572 17.3006 26.6572 17.1903V17.1719C26.6572 16.9882 26.7124 16.8044 26.8043 16.6573C27.0983 24.798 31.7291 28.5101 32.6295 29.1716Z",
    fill: "url(#paint167_radial_578_447472)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6292 16.1243V23.6953C29.7257 21.4902 28.1087 20.9573 27.2818 20.8654C27.0061 19.7444 26.8223 18.4948 26.7672 17.1166C26.7488 16.5653 27.1715 16.1243 27.7228 16.1243H32.6292Z",
    fill: "url(#paint168_radial_578_447472)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6045 16.1635H28.2772C27.3646 16.1635 26.6286 16.668 26.6581 17.2695C27.0113 23.2459 30.0434 27.1654 32.634 29.4163L32.6045 16.1635Z",
    fill: "url(#paint169_radial_578_447472)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8125 30.7706C63.8125 30.7706 69.3438 26.8564 69.7113 16.97C69.7297 16.4003 69.2703 15.9225 68.7006 15.9225H63.8125V30.7706Z",
    fill: "url(#paint170_radial_578_447472)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8125 15.9036V29.1345C63.8125 29.1345 63.8309 29.1345 63.8309 29.1161C63.8493 29.0977 63.8493 29.0977 63.8677 29.0977C63.9412 29.0426 64.0514 28.9691 64.2352 28.822C64.272 28.8037 64.3087 28.7669 64.3638 28.7302L64.3822 28.7118C64.4189 28.675 64.474 28.6383 64.5292 28.5832C64.5843 28.5464 64.6395 28.4913 64.6946 28.4545C64.713 28.4361 64.7497 28.3994 64.7681 28.381C64.8232 28.3259 64.8784 28.2708 64.9519 28.2157C64.9886 28.1789 65.0253 28.1421 65.0804 28.087C65.1356 28.0319 65.1908 27.9952 65.2275 27.94C65.3194 27.8481 65.4297 27.7378 65.5215 27.6276C65.5951 27.5541 65.6501 27.4806 65.7236 27.3887C65.7604 27.352 65.7971 27.3152 65.8339 27.2601C65.9074 27.1866 65.9809 27.0947 66.0544 27.0028C66.0912 26.9661 66.128 26.9109 66.1647 26.8741C66.2382 26.7823 66.3301 26.6904 66.4036 26.5801C66.4771 26.4882 66.5322 26.3964 66.6241 26.2862C66.6609 26.231 66.6976 26.1758 66.7343 26.1207C66.7711 26.0656 66.8078 26.0105 66.8446 25.9553C66.9181 25.8451 66.9916 25.7349 67.0651 25.6246C67.1386 25.496 67.2121 25.3857 67.2856 25.2755C67.3224 25.202 67.3591 25.1284 67.4143 25.0549C67.4326 24.9998 67.4878 24.9447 67.5062 24.8895C67.5429 24.816 67.5797 24.7609 67.6164 24.7058C67.6899 24.5771 67.7634 24.4301 67.8369 24.3015C67.8736 24.228 67.9104 24.1728 67.9472 24.0993C67.9839 24.0258 68.0207 23.9524 68.0574 23.8788C68.0942 23.8053 68.131 23.7318 68.1677 23.6583C68.278 23.4378 68.3699 23.2173 68.4618 22.9784C68.4801 22.9049 68.5169 22.8314 68.5352 22.7579C68.572 22.6476 68.6087 22.5557 68.6638 22.4454C68.6822 22.3719 68.7006 22.3168 68.7374 22.2617C68.8109 22.0412 68.8844 21.8207 68.9579 21.6185C68.9762 21.545 68.9946 21.4716 69.0313 21.3981C69.0497 21.3245 69.0682 21.251 69.1049 21.1591C69.1233 21.0856 69.1416 21.0121 69.16 20.9203C69.1968 20.7549 69.2336 20.5894 69.2887 20.4241C69.3071 20.3506 69.307 20.2955 69.3254 20.2036C69.3438 20.1117 69.3621 20.0014 69.3989 19.9096C69.4172 19.7993 69.4357 19.6707 69.4724 19.5788C69.5092 19.3399 69.5459 19.0826 69.601 18.8254C69.6194 18.6967 69.6378 18.5681 69.6562 18.4395C69.6746 18.3108 69.6745 18.1638 69.6929 18.0535C69.7113 17.7779 69.748 17.5023 69.7664 17.245C69.7664 17.1715 69.7848 17.0796 69.7848 17.0061C69.7848 16.9878 69.7848 16.9877 69.7848 16.9694V16.951C69.7848 16.7672 69.7297 16.5835 69.6378 16.4365C69.4541 16.1424 69.1416 15.9403 68.7741 15.9403L63.8125 15.9036Z",
    fill: "url(#paint171_radial_578_447472)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8125 28.9511V29.1532C63.8125 29.1532 63.8309 29.1533 63.8309 29.1349C63.8493 29.1165 63.8493 29.1165 63.8677 29.1165C63.9412 29.0614 64.0514 28.9879 64.2352 28.8409C64.272 28.8225 64.3087 28.7857 64.3638 28.749L64.3822 28.7306C64.4189 28.6938 64.474 28.6571 64.5292 28.6019C64.5843 28.5652 64.6395 28.5101 64.6946 28.4733C64.713 28.455 64.7497 28.4182 64.7681 28.3999C64.8232 28.3447 64.8784 28.2895 64.9519 28.2344C64.9886 28.1977 65.0253 28.161 65.0804 28.1058C65.1356 28.0507 65.1908 28.0139 65.2275 27.9588C65.3194 27.8669 65.4297 27.7567 65.5215 27.6464C65.5951 27.5729 65.6501 27.4994 65.7236 27.4075C65.7604 27.3707 65.7971 27.334 65.8339 27.2789C65.9074 27.2054 65.9809 27.1135 66.0544 27.0216C66.0912 26.9849 66.128 26.9297 66.1647 26.893C66.2382 26.8011 66.3301 26.7092 66.4036 26.5989C66.4771 26.5071 66.5322 26.4152 66.6241 26.3049C66.6609 26.2498 66.6976 26.1947 66.7343 26.1395C66.7711 26.0844 66.8078 26.0293 66.8446 25.9742C66.9181 25.8639 66.9916 25.7537 67.0651 25.6434C67.1386 25.5148 67.2121 25.4045 67.2856 25.2942C67.3224 25.2207 67.3591 25.1472 67.4143 25.0737C67.4326 25.0186 67.4878 24.9635 67.5062 24.9084C67.5429 24.8349 67.5797 24.7797 67.6164 24.7246C67.6899 24.596 67.7634 24.4489 67.8369 24.3203C67.8736 24.2468 67.9104 24.1916 67.9472 24.1181C67.9839 24.0446 68.0207 23.9712 68.0574 23.8977C68.0942 23.8242 68.131 23.7506 68.1677 23.6771C68.278 23.4566 68.3699 23.2361 68.4618 22.9972C68.4801 22.9237 68.5169 22.8502 68.5352 22.7767C68.572 22.6664 68.6087 22.5745 68.6638 22.4643C68.6822 22.3908 68.7006 22.3356 68.7374 22.2805C68.8109 22.06 68.8844 21.8395 68.9579 21.6373C68.9762 21.5638 68.9946 21.4904 69.0313 21.4169C69.0497 21.3434 69.0682 21.2698 69.1049 21.1779C69.1233 21.1044 69.1416 21.031 69.16 20.9391C69.1968 20.7737 69.2336 20.6083 69.2887 20.4429C69.3071 20.3694 69.307 20.3143 69.3254 20.2224C69.3438 20.1305 69.3621 20.0203 69.3989 19.9284C69.4172 19.8181 69.4357 19.6894 69.4724 19.5976C69.5092 19.3587 69.5459 19.1015 69.601 18.8442C69.6194 18.7156 69.6378 18.5869 69.6562 18.4583C69.6746 18.3296 69.6745 18.1826 69.6929 18.0724C69.7113 17.7967 69.748 17.5211 69.7664 17.2638C69.7664 17.1719 69.7848 17.08 69.7848 16.9698V16.9514C69.7848 16.7676 69.7297 16.5839 69.6378 16.4369C69.3438 24.5776 64.7313 28.2896 63.8125 28.9511Z",
    fill: "url(#paint172_radial_578_447472)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8125 15.9036V23.4745C66.716 21.2694 68.3331 20.7365 69.16 20.6446C69.4357 19.5237 69.6194 18.2741 69.6745 16.8959C69.6929 16.3446 69.2703 15.9036 68.719 15.9036H63.8125Z",
    fill: "url(#paint173_radial_578_447472)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1052 15.9036H68.2445C69.1174 15.9036 69.8214 16.3982 69.7932 16.9879C69.4553 22.8471 66.5551 26.6898 64.0771 28.8965L64.1052 15.9036Z",
    fill: "url(#paint174_radial_578_447472)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0889 16.6052C33.0889 16.6052 33.713 9.85797 42.0912 4.59647C42.5753 4.29572 43.2188 4.45467 43.5037 4.94801L45.9477 9.18116L33.0889 16.6052Z",
    fill: "url(#paint175_radial_578_447472)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9637 9.17227L34.5054 15.7877C34.5054 15.7877 34.4962 15.7719 34.5121 15.7627C34.5189 15.7376 34.5188 15.7376 34.5096 15.7217C34.5206 15.6304 34.5291 15.4982 34.5646 15.2656C34.5621 15.2245 34.5755 15.1743 34.5798 15.1082L34.5866 15.0831C34.6 15.0329 34.6043 14.9668 34.6245 14.8914C34.6287 14.8253 34.6489 14.7501 34.6531 14.6839C34.6599 14.6588 34.6734 14.6086 34.6801 14.5835C34.7003 14.5082 34.7205 14.4329 34.7314 14.3417C34.7449 14.2915 34.7583 14.2413 34.7785 14.166C34.7986 14.0907 34.803 14.0245 34.8323 13.9651C34.866 13.8396 34.9063 13.689 34.9558 13.5543C34.9827 13.4539 35.0189 13.3694 35.0617 13.2598C35.0751 13.2096 35.0885 13.1594 35.1179 13.1C35.1448 12.9996 35.1877 12.89 35.2305 12.7804C35.244 12.7302 35.2733 12.6708 35.2867 12.6206C35.3296 12.511 35.3632 12.3855 35.422 12.2667C35.4648 12.1571 35.5168 12.0634 35.5663 11.9287C35.5957 11.8693 35.625 11.8099 35.6544 11.7505C35.6838 11.6911 35.7131 11.6317 35.7425 11.5723C35.8012 11.4536 35.86 11.3348 35.9187 11.216C35.9934 11.088 36.0521 10.9692 36.1108 10.8504C36.1561 10.7819 36.2014 10.7133 36.2375 10.6288C36.276 10.5854 36.2963 10.51 36.3348 10.4665C36.3801 10.398 36.4095 10.3386 36.4388 10.2792C36.5135 10.1512 36.604 10.014 36.6786 9.88605C36.7239 9.81747 36.7533 9.75805 36.7985 9.68947C36.8438 9.62089 36.8892 9.55235 36.9345 9.48377C36.9797 9.41519 37.025 9.34662 37.0702 9.27804C37.2061 9.0723 37.3511 8.88243 37.5121 8.68342C37.5666 8.63075 37.6118 8.56221 37.6663 8.50954C37.7434 8.42259 37.8046 8.34477 37.8725 8.2419C37.927 8.18923 37.9655 8.14577 37.9949 8.08637C38.1491 7.91246 38.3033 7.73851 38.4416 7.57379C38.4961 7.52112 38.5506 7.46845 38.5959 7.39987C38.6504 7.3472 38.7048 7.29457 38.766 7.2168C38.8205 7.16413 38.8749 7.11151 38.9453 7.04966C39.0702 6.93514 39.195 6.82057 39.3107 6.69013C39.3652 6.63746 39.4129 6.60985 39.4833 6.54799C39.5537 6.48614 39.6399 6.41515 39.7011 6.33738C39.7874 6.26634 39.8897 6.18609 39.9509 6.10832C40.1394 5.95705 40.3438 5.79655 40.5391 5.62017C40.6413 5.53994 40.7434 5.45977 40.8457 5.37954C40.9479 5.29931 41.0752 5.22577 41.1615 5.15472C41.391 5.00099 41.6113 4.83136 41.8249 4.68681C41.8886 4.65006 41.959 4.58816 42.0227 4.55141C42.0386 4.54222 42.0385 4.54225 42.0545 4.53306L42.0704 4.52386C42.2295 4.43198 42.4163 4.38786 42.5896 4.39393C42.9361 4.40606 43.2673 4.57552 43.451 4.8938L45.9637 9.17227Z",
    fill: "url(#paint176_radial_578_447472)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6641 15.6958L34.489 15.7968C34.489 15.7968 34.4799 15.781 34.4958 15.7718C34.5025 15.7467 34.5025 15.7466 34.4933 15.7307C34.5043 15.6395 34.5129 15.5073 34.5483 15.2746C34.5458 15.2336 34.5593 15.1834 34.5635 15.1173L34.5702 15.0922C34.5837 15.042 34.5879 14.9759 34.6081 14.9006C34.6124 14.8344 34.6326 14.7591 34.6369 14.693C34.6436 14.6679 34.657 14.6177 34.6638 14.5926C34.684 14.5173 34.7041 14.442 34.7151 14.3508C34.7286 14.3006 34.742 14.2503 34.7622 14.175C34.7824 14.0997 34.7866 14.0336 34.816 13.9743C34.8496 13.8487 34.89 13.6981 34.9396 13.5634C34.9665 13.463 35.0025 13.3785 35.0453 13.2689C35.0588 13.2187 35.0723 13.1685 35.1016 13.1091C35.1285 13.0086 35.1714 12.8991 35.2142 12.7895C35.2276 12.7393 35.2569 12.6799 35.2704 12.6297C35.3132 12.5201 35.3469 12.3946 35.4056 12.2758C35.4484 12.1662 35.5004 12.0725 35.55 11.9378C35.5793 11.8784 35.6087 11.819 35.6381 11.7596C35.6674 11.7002 35.6968 11.6408 35.7261 11.5814C35.7849 11.4627 35.8437 11.3439 35.9024 11.2251C35.9771 11.0971 36.0358 10.9783 36.0945 10.8595C36.1398 10.791 36.1851 10.7224 36.2212 10.6379C36.2598 10.5944 36.2799 10.5191 36.3185 10.4757C36.3638 10.4071 36.3931 10.3477 36.4225 10.2883C36.4971 10.1603 36.5876 10.0231 36.6623 9.89516C36.7076 9.82658 36.7369 9.76716 36.7822 9.69858C36.8275 9.63 36.8728 9.56146 36.9181 9.49288C36.9634 9.4243 37.0086 9.35573 37.0539 9.28715C37.1897 9.0814 37.3348 8.89154 37.4957 8.69252C37.5502 8.63986 37.5955 8.57127 37.65 8.51861C37.7271 8.43165 37.7882 8.35388 37.8562 8.251C37.9106 8.19834 37.9492 8.15487 37.9786 8.09548C38.1328 7.92157 38.287 7.74762 38.4253 7.58289C38.4798 7.53023 38.5343 7.47756 38.5796 7.40898C38.634 7.35631 38.6885 7.30368 38.7497 7.22591C38.8041 7.17324 38.8587 7.12058 38.929 7.05872C39.0539 6.9442 39.1787 6.82967 39.2944 6.69924C39.3488 6.64657 39.3966 6.61896 39.467 6.5571C39.5373 6.49525 39.6237 6.42421 39.6849 6.34644C39.7712 6.2754 39.8734 6.1952 39.9345 6.11743C40.1231 5.96616 40.3275 5.80565 40.5227 5.62928C40.6249 5.54905 40.7272 5.46884 40.8294 5.38861C40.9316 5.30837 41.0588 5.23487 41.1451 5.16383C41.3747 5.01009 41.5951 4.84042 41.8087 4.69588C41.8882 4.64993 41.9586 4.5881 42.054 4.53297L42.07 4.52377C42.2291 4.43189 42.4159 4.38777 42.5892 4.39384C35.6861 8.71881 34.7868 14.5852 34.6641 15.6958Z",
    fill: "url(#paint177_radial_578_447472)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9635 9.172L39.4068 12.9575C39.8648 9.34049 39.5178 7.67365 39.1839 6.91156C40.0168 6.11237 41.0071 5.32835 42.1732 4.5915C42.6414 4.29994 43.2347 4.44549 43.5103 4.92292L45.9635 9.172Z",
    fill: "url(#paint178_radial_578_447472)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M45.917 9.17016L43.7533 5.42258C43.297 4.63225 42.4921 4.24717 41.9859 4.57342C36.9868 7.86755 35.1085 12.4532 34.4545 15.8221L45.917 9.17016Z",
    fill: "url(#paint179_radial_578_447472)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5087 16.6052C63.5087 16.6052 62.8846 9.85797 54.5065 4.59647C54.0223 4.29572 53.3788 4.45467 53.094 4.94801L50.65 9.18116L63.5087 16.6052Z",
    fill: "url(#paint180_radial_578_447472)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6349 9.17227L62.0933 15.7877C62.0933 15.7877 62.1024 15.7719 62.0865 15.7627C62.0798 15.7376 62.0798 15.7376 62.089 15.7217C62.078 15.6304 62.0695 15.4982 62.0341 15.2656C62.0365 15.2245 62.0231 15.1743 62.0188 15.1082L62.0121 15.0831C61.9986 15.0329 61.9943 14.9668 61.9742 14.8914C61.9699 14.8253 61.9498 14.7501 61.9455 14.6839C61.9388 14.6588 61.9252 14.6086 61.9185 14.5835C61.8983 14.5082 61.8782 14.4329 61.8672 14.3417C61.8537 14.2915 61.8403 14.2413 61.8202 14.166C61.8 14.0907 61.7957 14.0245 61.7663 13.9651C61.7327 13.8396 61.6924 13.689 61.6428 13.5543C61.6159 13.4539 61.5798 13.3694 61.537 13.2598C61.5235 13.2096 61.5101 13.1594 61.4807 13.1C61.4538 12.9996 61.4109 12.89 61.3681 12.7804C61.3547 12.7302 61.3253 12.6708 61.3119 12.6206C61.2691 12.511 61.2354 12.3855 61.1767 12.2667C61.1339 12.1571 61.0819 12.0634 61.0323 11.9287C61.0029 11.8693 60.9736 11.8099 60.9442 11.7505C60.9149 11.6911 60.8855 11.6317 60.8562 11.5723C60.7974 11.4536 60.7386 11.3348 60.6799 11.216C60.6052 11.088 60.5465 10.9692 60.4878 10.8504C60.4425 10.7819 60.3973 10.7133 60.3612 10.6288C60.3226 10.5854 60.3024 10.51 60.2638 10.4665C60.2185 10.398 60.1892 10.3386 60.1598 10.2792C60.0852 10.1512 59.9947 10.014 59.92 9.88605C59.8747 9.81747 59.8454 9.75805 59.8001 9.68947C59.7548 9.62089 59.7095 9.55235 59.6642 9.48377C59.6189 9.41519 59.5737 9.34662 59.5284 9.27804C59.3925 9.0723 59.2475 8.88243 59.0865 8.68342C59.0321 8.63075 58.9868 8.56221 58.9324 8.50954C58.8553 8.42259 58.794 8.34477 58.7261 8.2419C58.6717 8.18923 58.6331 8.14577 58.6037 8.08637C58.4495 7.91246 58.2953 7.73851 58.157 7.57379C58.1025 7.52112 58.048 7.46845 58.0027 7.39987C57.9483 7.3472 57.8938 7.29457 57.8326 7.2168C57.7782 7.16413 57.7237 7.11151 57.6533 7.04966C57.5285 6.93514 57.4036 6.82057 57.2879 6.69013C57.2335 6.63746 57.1857 6.60985 57.1153 6.54799C57.0449 6.48614 56.9587 6.41515 56.8975 6.33738C56.8112 6.26634 56.7089 6.18609 56.6477 6.10832C56.4592 5.95705 56.2548 5.79655 56.0596 5.62017C55.9574 5.53994 55.8552 5.45977 55.753 5.37954C55.6508 5.29931 55.5235 5.22577 55.4372 5.15472C55.2076 5.00099 54.9873 4.83136 54.7737 4.68681C54.71 4.65006 54.6396 4.58816 54.576 4.55141C54.56 4.54222 54.5601 4.54225 54.5442 4.53306L54.5282 4.52386C54.3691 4.43198 54.1823 4.38786 54.0091 4.39393C53.6626 4.40606 53.3314 4.57552 53.1476 4.8938L50.6349 9.17227Z",
    fill: "url(#paint181_radial_578_447472)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9345 15.6959L62.1096 15.797C62.1096 15.797 62.1187 15.7811 62.1028 15.7719C62.0961 15.7468 62.0961 15.7468 62.1053 15.7309C62.0943 15.6396 62.0858 15.5074 62.0503 15.2747C62.0528 15.2337 62.0394 15.1835 62.0351 15.1174L62.0284 15.0924C62.015 15.0422 62.0107 14.976 61.9905 14.9007C61.9862 14.8346 61.966 14.7592 61.9618 14.6931C61.955 14.668 61.9416 14.6178 61.9349 14.5927C61.9147 14.5174 61.8945 14.4421 61.8835 14.3509C61.8701 14.3007 61.8566 14.2505 61.8364 14.1751C61.8163 14.0998 61.812 14.0338 61.7826 13.9744C61.749 13.8489 61.7086 13.6982 61.6591 13.5635C61.6322 13.4631 61.5961 13.3786 61.5533 13.269C61.5399 13.2188 61.5264 13.1686 61.497 13.1092C61.4701 13.0088 61.4273 12.8992 61.3845 12.7896C61.371 12.7394 61.3417 12.68 61.3282 12.6298C61.2854 12.5202 61.2518 12.3947 61.193 12.276C61.1502 12.1664 61.0982 12.0726 61.0487 11.9379C61.0193 11.8785 60.9899 11.8191 60.9606 11.7598C60.9312 11.7004 60.9019 11.641 60.8725 11.5816C60.8138 11.4628 60.755 11.344 60.6962 11.2252C60.6216 11.0973 60.5629 10.9784 60.5041 10.8597C60.4589 10.7911 60.4135 10.7225 60.3774 10.638C60.3389 10.5946 60.3187 10.5193 60.2802 10.4758C60.2349 10.4072 60.2055 10.3478 60.1762 10.2884C60.1015 10.1604 60.011 10.0233 59.9364 9.89528C59.8911 9.8267 59.8617 9.76728 59.8164 9.6987C59.7711 9.63012 59.7258 9.56158 59.6805 9.493C59.6352 9.42442 59.59 9.35585 59.5447 9.28727C59.4089 9.08153 59.2638 8.89166 59.1029 8.69265C59.0484 8.63998 59.0031 8.5714 58.9486 8.51873C58.8715 8.43177 58.8104 8.354 58.7425 8.25113C58.688 8.19846 58.6494 8.155 58.6201 8.0956C58.4658 7.92169 58.3116 7.74774 58.1733 7.58302C58.1189 7.53035 58.0644 7.47768 58.0191 7.4091C57.9646 7.35643 57.9102 7.3038 57.849 7.22603C57.7945 7.17336 57.74 7.1207 57.6696 7.05884C57.5447 6.94432 57.4199 6.8298 57.3043 6.69936C57.2498 6.64669 57.2021 6.61908 57.1317 6.55722C57.0613 6.49537 56.975 6.42433 56.9138 6.34656C56.8275 6.27552 56.7253 6.19532 56.6641 6.11755C56.4756 5.96628 56.2712 5.80578 56.0759 5.6294C55.9737 5.54917 55.8715 5.46896 55.7692 5.38873C55.667 5.3085 55.5398 5.235 55.4535 5.16395C55.224 5.01022 55.0036 4.84055 54.79 4.696C54.7104 4.65006 54.6401 4.58822 54.5446 4.53309L54.5287 4.5239C54.3695 4.43201 54.1827 4.3879 54.0095 4.39396C60.9125 8.71894 61.8118 14.5853 61.9345 15.6959Z",
    fill: "url(#paint182_radial_578_447472)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6351 9.172L57.1918 12.9575C56.7339 9.34049 57.0809 7.67365 57.4148 6.91156C56.5818 6.11237 55.5915 5.32835 54.4255 4.5915C53.9572 4.29994 53.364 4.44549 53.0883 4.92292L50.6351 9.172Z",
    fill: "url(#paint183_radial_578_447472)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6816 9.17016L52.8453 5.42258C53.3016 4.63225 54.1065 4.24717 54.6127 4.57342C59.6118 7.86755 61.4902 12.4532 62.1442 15.8221L50.6816 9.17016Z",
    fill: "url(#paint184_radial_578_447472)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1362 30.7156C35.1362 30.7156 30.4679 27.4122 30.1577 19.068C30.1422 18.5872 30.5299 18.184 31.0107 18.184H35.1362V30.7156Z",
    fill: "url(#paint185_radial_578_447472)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1363 18.1688V29.3357C35.1363 29.3357 35.1209 29.3357 35.1209 29.3202C35.1054 29.3047 35.1053 29.3047 35.0898 29.3047C35.0278 29.2582 34.9347 29.1962 34.7796 29.0721C34.7486 29.0566 34.7176 29.0256 34.671 28.9945L34.6556 28.979C34.6246 28.948 34.578 28.9169 34.5315 28.8704C34.4849 28.8394 34.4384 28.7929 34.3919 28.7619C34.3764 28.7464 34.3454 28.7153 34.3299 28.6998C34.2833 28.6533 34.2368 28.6068 34.1748 28.5602C34.1437 28.5292 34.1127 28.4982 34.0662 28.4517C34.0196 28.4052 33.9731 28.3741 33.9421 28.3276C33.8646 28.25 33.7715 28.157 33.694 28.064C33.6319 28.0019 33.5854 27.9398 33.5233 27.8623C33.4923 27.8313 33.4613 27.8003 33.4303 27.7538C33.3682 27.6917 33.3062 27.6141 33.2442 27.5366C33.2132 27.5056 33.1821 27.4591 33.1511 27.4281C33.0891 27.3505 33.0116 27.2729 32.9495 27.1799C32.8875 27.1023 32.8409 27.0248 32.7634 26.9317C32.7324 26.8852 32.7013 26.8387 32.6703 26.7922C32.6393 26.7456 32.6083 26.6991 32.5772 26.6526C32.5152 26.5595 32.4532 26.4664 32.3912 26.3734C32.3291 26.2648 32.2671 26.1718 32.205 26.0787C32.174 26.0167 32.143 25.9547 32.0965 25.8926C32.081 25.8461 32.0345 25.7995 32.0189 25.753C31.9879 25.6909 31.9569 25.6444 31.9259 25.5979C31.8638 25.4893 31.8018 25.3653 31.7397 25.2567C31.7087 25.1947 31.6777 25.1481 31.6467 25.0861C31.6156 25.0241 31.5847 24.962 31.5537 24.9C31.5226 24.8379 31.4916 24.7759 31.4606 24.7139C31.3675 24.5278 31.29 24.3416 31.2124 24.14C31.1969 24.078 31.1659 24.016 31.1504 23.9539C31.1194 23.8609 31.0883 23.7833 31.0418 23.6902C31.0263 23.6282 31.0108 23.5817 30.9798 23.5351C30.9177 23.349 30.8557 23.1629 30.7936 22.9923C30.7781 22.9303 30.7626 22.8682 30.7316 22.8062C30.7161 22.7441 30.7006 22.6821 30.6696 22.6046C30.6541 22.5425 30.6386 22.4805 30.6231 22.403C30.5921 22.2634 30.561 22.1238 30.5145 21.9842C30.499 21.9222 30.499 21.8756 30.4834 21.798C30.4679 21.7205 30.4524 21.6275 30.4214 21.55C30.4059 21.4569 30.3904 21.3483 30.3594 21.2707C30.3284 21.0691 30.2973 20.852 30.2508 20.6348C30.2353 20.5263 30.2198 20.4178 30.2043 20.3092C30.1888 20.2006 30.1888 20.0765 30.1733 19.9835C30.1577 19.7508 30.1267 19.5182 30.1112 19.3011C30.1112 19.239 30.0957 19.1614 30.0957 19.0994C30.0957 19.0839 30.0957 19.0839 30.0957 19.0684V19.0529C30.0957 18.8978 30.1423 18.7427 30.2198 18.6186C30.3749 18.3704 30.6385 18.1999 30.9487 18.1999L35.1363 18.1688Z",
    fill: "url(#paint186_radial_578_447472)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1363 29.1807V29.3513C35.1363 29.3513 35.1209 29.3513 35.1209 29.3358C35.1054 29.3203 35.1053 29.3202 35.0898 29.3202C35.0278 29.2737 34.9347 29.2117 34.7796 29.0876C34.7486 29.0721 34.7176 29.0411 34.671 29.0101L34.6556 28.9946C34.6246 28.9636 34.578 28.9325 34.5315 28.886C34.4849 28.855 34.4384 28.8084 34.3919 28.7774C34.3764 28.7619 34.3454 28.7309 34.3299 28.7154C34.2833 28.6689 34.2368 28.6223 34.1748 28.5758C34.1437 28.5448 34.1127 28.5138 34.0662 28.4672C34.0196 28.4207 33.9731 28.3897 33.9421 28.3432C33.8646 28.2656 33.7715 28.1725 33.694 28.0795C33.6319 28.0174 33.5854 27.9554 33.5233 27.8779C33.4923 27.8469 33.4613 27.8158 33.4303 27.7693C33.3682 27.7073 33.3062 27.6297 33.2442 27.5522C33.2132 27.5212 33.1821 27.4747 33.1511 27.4437C33.0891 27.3661 33.0116 27.2885 32.9495 27.1955C32.8875 27.1179 32.8409 27.0404 32.7634 26.9473C32.7324 26.9008 32.7013 26.8543 32.6703 26.8077C32.6393 26.7612 32.6083 26.7147 32.5772 26.6682C32.5152 26.5751 32.4532 26.482 32.3912 26.389C32.3291 26.2804 32.2671 26.1873 32.205 26.0943C32.174 26.0323 32.143 25.9702 32.0965 25.9081C32.081 25.8616 32.0345 25.8151 32.0189 25.7686C31.9879 25.7065 31.9569 25.66 31.9259 25.6135C31.8638 25.5049 31.8018 25.3809 31.7397 25.2723C31.7087 25.2103 31.6777 25.1637 31.6467 25.1017C31.6156 25.0397 31.5847 24.9776 31.5537 24.9155C31.5226 24.8535 31.4916 24.7915 31.4606 24.7295C31.3675 24.5434 31.29 24.3572 31.2124 24.1556C31.1969 24.0936 31.1659 24.0315 31.1504 23.9694C31.1194 23.8764 31.0883 23.7989 31.0418 23.7058C31.0263 23.6438 31.0108 23.5973 30.9798 23.5507C30.9177 23.3646 30.8557 23.1785 30.7936 23.0079C30.7781 22.9459 30.7626 22.8838 30.7316 22.8218C30.7161 22.7597 30.7006 22.6977 30.6696 22.6202C30.6541 22.5581 30.6386 22.496 30.6231 22.4185C30.5921 22.2789 30.561 22.1394 30.5145 21.9998C30.499 21.9377 30.499 21.8912 30.4834 21.8136C30.4679 21.7361 30.4524 21.643 30.4214 21.5655C30.4059 21.4724 30.3904 21.3639 30.3594 21.2863C30.3284 21.0847 30.2973 20.8676 30.2508 20.6504C30.2353 20.5419 30.2198 20.4333 30.2043 20.3247C30.1888 20.2161 30.1888 20.0921 30.1733 19.9991C30.1577 19.7664 30.1267 19.5337 30.1112 19.3166C30.1112 19.239 30.0957 19.1615 30.0957 19.0685V19.053C30.0957 18.8979 30.1423 18.7427 30.2198 18.6187C30.468 25.4894 34.3763 28.6223 35.1363 29.1807Z",
    fill: "url(#paint187_radial_578_447472)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1355 18.1688V24.5588C32.685 22.6976 31.3202 22.2479 30.6223 22.1703C30.3897 21.2243 30.2345 20.1695 30.188 19.0063C30.1725 18.541 30.5292 18.1688 30.9945 18.1688H35.1355Z",
    fill: "url(#paint188_radial_578_447472)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1152 18.2019H31.4629C30.6927 18.2019 30.0716 18.6277 30.0964 19.1354C30.3946 24.1795 32.9536 27.4875 35.1401 29.3873L35.1152 18.2019Z",
    fill: "url(#paint189_radial_578_447472)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4551 30.5302C61.4551 30.5302 66.1235 27.2266 66.4337 18.8825C66.4492 18.4017 66.0614 17.9984 65.5806 17.9984H61.4551V30.5302Z",
    fill: "url(#paint190_radial_578_447472)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4551 17.9825V29.1494C61.4551 29.1494 61.4706 29.1494 61.4706 29.1339C61.4861 29.1184 61.4861 29.1184 61.5017 29.1184C61.5637 29.0718 61.6567 29.0098 61.8118 28.8857C61.8429 28.8702 61.8738 28.8392 61.9204 28.8082L61.9359 28.7927C61.9669 28.7616 62.0134 28.7307 62.0599 28.6841C62.1065 28.6531 62.1531 28.6066 62.1996 28.5755C62.2151 28.56 62.2461 28.529 62.2616 28.5135C62.3081 28.467 62.3547 28.4205 62.4167 28.3739C62.4477 28.3429 62.4787 28.3119 62.5252 28.2653C62.5718 28.2188 62.6183 28.1878 62.6493 28.1413C62.7269 28.0638 62.82 27.9707 62.8975 27.8776C62.9596 27.8156 63.006 27.7536 63.0681 27.676C63.0991 27.645 63.1301 27.6139 63.1611 27.5674C63.2232 27.5054 63.2852 27.4278 63.3473 27.3503C63.3783 27.3193 63.4093 27.2727 63.4403 27.2417C63.5024 27.1642 63.5799 27.0866 63.6419 26.9935C63.704 26.916 63.7505 26.8385 63.8281 26.7454C63.8591 26.6989 63.8901 26.6523 63.9211 26.6058C63.9521 26.5593 63.9831 26.5128 64.0142 26.4662C64.0762 26.3732 64.1383 26.2801 64.2003 26.1871C64.2623 26.0785 64.3243 25.9855 64.3864 25.8924C64.4174 25.8304 64.4484 25.7683 64.495 25.7063C64.5105 25.6597 64.557 25.6132 64.5725 25.5667C64.6035 25.5047 64.6346 25.4581 64.6656 25.4116C64.7276 25.303 64.7896 25.1789 64.8517 25.0704C64.8827 25.0083 64.9137 24.9618 64.9447 24.8997C64.9757 24.8377 65.0068 24.7757 65.0378 24.7137C65.0688 24.6516 65.0999 24.5896 65.1309 24.5275C65.2239 24.3414 65.3015 24.1553 65.379 23.9537C65.3946 23.8917 65.4256 23.8296 65.4411 23.7676C65.4721 23.6745 65.5031 23.5969 65.5496 23.5039C65.5651 23.4418 65.5807 23.3953 65.6117 23.3488C65.6737 23.1627 65.7357 22.9766 65.7978 22.806C65.8133 22.7439 65.8288 22.6819 65.8598 22.6199C65.8753 22.5578 65.8909 22.4958 65.9219 22.4182C65.9374 22.3562 65.9529 22.2942 65.9684 22.2166C65.9994 22.077 66.0304 21.9374 66.077 21.7978C66.0925 21.7358 66.0924 21.6893 66.1079 21.6118C66.1235 21.5342 66.139 21.4411 66.17 21.3636C66.1855 21.2705 66.2011 21.162 66.2321 21.0845C66.2631 20.8828 66.2941 20.6657 66.3406 20.4485C66.3561 20.34 66.3717 20.2314 66.3872 20.1228C66.4027 20.0143 66.4026 19.8902 66.4181 19.7971C66.4336 19.5645 66.4647 19.3318 66.4802 19.1147C66.4802 19.0527 66.4957 18.9752 66.4957 18.9131C66.4957 18.8976 66.4957 18.8976 66.4957 18.8821V18.8665C66.4957 18.7114 66.4492 18.5564 66.3716 18.4323C66.2165 18.1842 65.9529 18.0135 65.6427 18.0135L61.4551 17.9825Z",
    fill: "url(#paint191_radial_578_447472)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4551 28.9946V29.1652C61.4551 29.1652 61.4706 29.1652 61.4706 29.1497C61.4861 29.1342 61.4861 29.1342 61.5017 29.1342C61.5637 29.0877 61.6567 29.0256 61.8118 28.9016C61.8429 28.8861 61.8738 28.855 61.9204 28.824L61.9359 28.8085C61.9669 28.7775 62.0134 28.7464 62.0599 28.6999C62.1065 28.6689 62.1531 28.6224 62.1996 28.5914C62.2151 28.5759 62.2461 28.5449 62.2616 28.5294C62.3081 28.4828 62.3547 28.4362 62.4167 28.3897C62.4477 28.3587 62.4787 28.3277 62.5252 28.2812C62.5718 28.2347 62.6183 28.2036 62.6493 28.1571C62.7269 28.0795 62.82 27.9865 62.8975 27.8934C62.9596 27.8314 63.006 27.7693 63.0681 27.6918C63.0991 27.6608 63.1301 27.6298 63.1611 27.5833C63.2232 27.5212 63.2852 27.4437 63.3473 27.3661C63.3783 27.3351 63.4093 27.2886 63.4403 27.2575C63.5024 27.18 63.5799 27.1024 63.6419 27.0094C63.704 26.9318 63.7505 26.8543 63.8281 26.7612C63.8591 26.7147 63.8901 26.6682 63.9211 26.6216C63.9521 26.5751 63.9831 26.5286 64.0142 26.4821C64.0762 26.389 64.1383 26.296 64.2003 26.2029C64.2623 26.0944 64.3243 26.0012 64.3864 25.9082C64.4174 25.8461 64.4484 25.7841 64.495 25.7221C64.5105 25.6756 64.557 25.6291 64.5725 25.5825C64.6035 25.5205 64.6346 25.474 64.6656 25.4274C64.7276 25.3189 64.7896 25.1948 64.8517 25.0862C64.8827 25.0242 64.9137 24.9776 64.9447 24.9156C64.9757 24.8535 65.0068 24.7916 65.0378 24.7295C65.0688 24.6675 65.0999 24.6054 65.1309 24.5434C65.2239 24.3573 65.3015 24.1711 65.379 23.9695C65.3946 23.9074 65.4256 23.8455 65.4411 23.7834C65.4721 23.6904 65.5031 23.6128 65.5496 23.5197C65.5651 23.4577 65.5807 23.4112 65.6117 23.3646C65.6737 23.1785 65.7357 22.9924 65.7978 22.8218C65.8133 22.7598 65.8288 22.6978 65.8598 22.6357C65.8753 22.5737 65.8909 22.5116 65.9219 22.4341C65.9374 22.372 65.9529 22.31 65.9684 22.2325C65.9994 22.0929 66.0304 21.9533 66.077 21.8137C66.0925 21.7516 66.0924 21.7051 66.1079 21.6276C66.1235 21.5501 66.139 21.457 66.17 21.3794C66.1855 21.2864 66.2011 21.1778 66.2321 21.1002C66.2631 20.8986 66.2941 20.6815 66.3406 20.4644C66.3561 20.3558 66.3717 20.2472 66.3872 20.1387C66.4027 20.0301 66.4026 19.906 66.4181 19.813C66.4336 19.5803 66.4647 19.3477 66.4802 19.1305C66.4802 19.053 66.4957 18.9754 66.4957 18.8824V18.8669C66.4957 18.7118 66.4492 18.5567 66.3716 18.4326C66.1235 25.3034 62.2306 28.4363 61.4551 28.9946Z",
    fill: "url(#paint192_radial_578_447472)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4551 17.9825V24.3724C63.9056 22.5113 65.2704 22.0615 65.9684 21.984C66.201 21.0379 66.3561 19.9833 66.4026 18.82C66.4181 18.3548 66.0614 17.9825 65.5962 17.9825H61.4551Z",
    fill: "url(#paint193_radial_578_447472)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7014 17.9825H65.195C65.9317 17.9825 66.5259 18.4 66.5021 18.8977C66.2169 23.8429 63.7691 27.0861 61.6777 28.9486L61.7014 17.9825Z",
    fill: "url(#paint194_radial_578_447472)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6904 15.2975V31.51C32.6904 32.3105 33.1125 33.0527 33.7965 33.4747L47.2148 41.5083C47.9425 41.9449 48.8448 41.9449 49.5579 41.5083L62.9763 33.4747C63.6603 33.0672 64.0823 32.325 64.0823 31.51V15.2975C64.0823 14.497 63.6603 13.7548 62.9763 13.3327L49.5579 5.29926C48.8302 4.86265 47.9279 4.86265 47.2148 5.29926L33.7965 13.3327C33.1125 13.7548 32.6904 14.497 32.6904 15.2975Z",
    fill: "url(#paint195_radial_578_447472)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0969 14.2205V30.4913C64.0969 31.0589 63.7913 31.5974 63.2965 31.8739L49.2087 40.0093C48.7139 40.3004 48.1026 40.3004 47.5933 40.0093L33.5055 31.8739C33.0107 31.5828 32.7051 31.0589 32.7051 30.4913V14.2205C32.7051 13.6529 33.0107 13.1145 33.5055 12.8379L47.5933 4.70256C48.0881 4.41149 48.6993 4.41149 49.2087 4.70256L63.2965 12.8379C63.7913 13.1145 64.0969 13.6384 64.0969 14.2205Z",
    fill: "url(#paint196_linear_578_447472)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2965 12.8238L49.2087 4.68839C48.7139 4.39733 48.1026 4.39733 47.5933 4.68839L33.5055 12.8238C33.0107 13.1148 32.7051 13.6388 32.7051 14.2209V14.8613C32.7051 14.2937 33.0107 13.7552 33.5055 13.4641L47.5933 5.32873C48.0881 5.03766 48.6993 5.03766 49.2087 5.32873L63.2965 13.4641C63.7913 13.7552 64.0969 14.2791 64.0969 14.8613V14.2209C64.0969 13.6388 63.7913 13.1148 63.2965 12.8238Z",
    fill: "url(#paint197_radial_578_447472)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2965 31.7719L49.2087 39.9073C48.7139 40.1984 48.1026 40.1984 47.5933 39.9073L33.5055 31.7719C33.0107 31.4808 32.7051 30.9569 32.7051 30.3748V30.4767C32.7051 31.0442 33.0107 31.5827 33.5055 31.8737L47.5933 40.0092C48.0881 40.3003 48.6993 40.3003 49.2087 40.0092L63.2965 31.8737C63.7913 31.5827 64.0969 31.0588 64.0969 30.4767V30.3748C64.0969 30.9569 63.7913 31.4954 63.2965 31.7719Z",
    fill: "url(#paint198_radial_578_447472)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0968 16.4326H32.6904V23.2145H64.0968V16.4326Z",
    fill: "url(#paint199_radial_578_447472)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0968 23.2148H32.6904V29.9968H64.0968V23.2148Z",
    fill: "url(#paint200_radial_578_447472)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2953 12.8235L49.2075 4.68815C48.7127 4.39708 48.1014 4.39708 47.5921 4.68815L33.5043 12.8235C33.4752 12.8381 33.4461 12.8526 33.417 12.8817L46.9517 5.06656C47.4466 4.77549 48.0578 4.77549 48.5672 5.06656L62.6549 13.2019C63.1498 13.493 63.4554 14.0169 63.4554 14.5845V30.8553C63.4554 31.3938 63.1934 31.9032 62.7277 32.1942L63.2808 31.874C63.7756 31.583 64.0812 31.059 64.0812 30.4914V14.2207C64.0958 13.6385 63.7901 13.1146 63.2953 12.8235Z",
    fill: "url(#paint201_radial_578_447472)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2964 31.7722L49.2086 39.9076C48.7138 40.1987 48.1026 40.1987 47.5932 39.9076L33.5054 31.7722C33.1853 31.583 32.9378 31.2919 32.8068 30.9572V15.1958C32.8068 14.5991 33.0397 14.0606 33.4181 13.6385C32.9669 14.0752 32.6904 14.6718 32.6904 15.3122V30.3896V30.4915V31.5102C32.6904 32.3106 33.1125 33.0529 33.7965 33.4749L47.2148 41.5085C47.9425 41.9451 48.8448 41.9451 49.5579 41.5085L62.9763 33.4749C63.1654 33.373 63.3255 33.2276 63.4711 33.082C63.3546 33.1839 63.2236 33.2858 63.0781 33.3731L49.6598 41.4066C48.9321 41.8432 48.0298 41.8432 47.3167 41.4066L33.8983 33.3731C33.2143 32.9656 32.7923 32.2234 32.7923 31.4084V31.0591C32.9233 31.4084 33.1707 31.6994 33.4909 31.874L47.5786 40.0095C48.0734 40.3006 48.6847 40.3006 49.1941 40.0095L63.2819 31.874C63.7767 31.583 64.0823 31.0591 64.0823 30.477V30.3751C64.0969 30.9572 63.7912 31.4957 63.2964 31.7722Z",
    fill: "url(#paint202_radial_578_447472)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8916 16.5056V29.5164C35.8916 29.953 36.1245 30.3605 36.5029 30.5642L47.7673 37.0697C48.1457 37.288 48.6113 37.288 48.9897 37.0697L60.2541 30.5642C60.6325 30.3459 60.8654 29.9385 60.8654 29.5164V16.5056C60.8654 16.069 60.6325 15.6615 60.2541 15.4577L48.9897 8.9523C48.6113 8.734 48.1457 8.734 47.7673 8.9523L36.5029 15.4577C36.1245 15.6615 35.8916 16.0545 35.8916 16.5056Z",
    fill: "url(#paint203_linear_578_447472)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5459 16.8405V29.1673C36.5459 29.5748 36.7642 29.9678 37.128 30.1715L47.7957 36.3276C48.145 36.5313 48.5962 36.5313 48.9455 36.3276L59.6132 30.1715C59.9625 29.9678 60.1953 29.5748 60.1953 29.1673V16.8405C60.1953 16.433 59.977 16.0401 59.6132 15.8363L48.9455 9.68016C48.5962 9.47641 48.145 9.47641 47.7957 9.68016L37.128 15.8363C36.7642 16.0401 36.5459 16.4184 36.5459 16.8405Z",
    fill: "url(#paint204_radial_578_447472)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5459 16.8405V29.1673C36.5459 29.5748 36.7642 29.9678 37.128 30.1715L47.7957 36.3276C48.145 36.5313 48.5962 36.5313 48.9455 36.3276L59.6132 30.1715C59.9625 29.9678 60.1953 29.5748 60.1953 29.1673V16.8405C60.1953 16.433 59.977 16.0401 59.6132 15.8363L48.9455 9.68016C48.5962 9.47641 48.145 9.47641 47.7957 9.68016L37.128 15.8363C36.7642 16.0401 36.5459 16.4184 36.5459 16.8405Z",
    fill: "url(#paint205_radial_578_447472)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9355 16.4622C35.9355 16.0255 36.1684 15.6181 36.5468 15.4143L47.8112 8.90891C48.1896 8.69061 48.6553 8.69061 49.0337 8.90891L60.2981 15.4143C60.6765 15.6326 60.9093 16.0401 60.9093 16.4622V16.3021C60.9093 15.8654 60.6765 15.458 60.2981 15.2542L49.0337 8.74881C48.6553 8.53051 48.1896 8.53051 47.8112 8.74881L36.5468 15.2542C36.1684 15.4725 35.9355 15.88 35.9355 16.3021V29.3129V16.4622Z",
    fill: "url(#paint206_radial_578_447472)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2541 30.3606L48.9897 36.866C48.6113 37.0843 48.1457 37.0843 47.7673 36.866L36.5029 30.3606C36.1245 30.1423 35.8916 29.7348 35.8916 29.3127V29.5019C35.8916 29.9385 36.1245 30.346 36.5029 30.5498L47.7673 37.0552C48.1457 37.2735 48.6113 37.2735 48.9897 37.0552L60.2541 30.5498C60.6325 30.3315 60.8654 29.924 60.8654 29.5019V29.3127C60.8654 29.7348 60.618 30.1423 60.2541 30.3606Z",
    fill: "url(#paint207_radial_578_447472)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6278 15.8363L48.9601 9.68016C48.6108 9.47641 48.1596 9.47641 47.8104 9.68016L37.1427 15.8363C36.7934 16.0401 36.5605 16.433 36.5605 16.8405V29.1673C36.5605 29.5748 36.7788 29.9678 37.1427 30.1715L47.8104 36.3276C48.1596 36.5313 48.6108 36.5313 48.9601 36.3276L59.6278 30.1715C59.9771 29.9678 60.21 29.5748 60.21 29.1673V16.8405C60.21 16.4184 59.9917 16.0401 59.6278 15.8363ZM59.6424 28.8763C59.6424 29.2692 59.4386 29.633 59.0893 29.8367L48.9164 35.7164C48.5672 35.9056 48.1597 35.9056 47.8249 35.7164L37.6521 29.8367C37.3028 29.6475 37.099 29.2838 37.099 28.8763V17.1316C37.099 16.7386 37.3028 16.3748 37.6521 16.171L47.8249 10.2914C48.1742 10.1022 48.5817 10.1022 48.9164 10.2914L59.0893 16.171C59.4386 16.3602 59.6424 16.7241 59.6424 17.1316V28.8763Z",
    fill: "url(#paint208_linear_578_447472)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0517 29.6329V16.6221C36.0517 16.1855 36.2845 15.778 36.6629 15.5742L47.9274 9.06886C48.3058 8.85056 48.7715 8.85056 49.1498 9.06886L60.4142 15.5742C60.4433 15.5888 60.487 15.6179 60.5161 15.6325C60.4434 15.5597 60.356 15.4869 60.2541 15.4433L48.9897 8.9379C48.6114 8.71959 48.1457 8.71959 47.7673 8.9379L36.5029 15.4433C36.1245 15.6616 35.8916 16.0691 35.8916 16.4911V29.5019C35.8916 29.8949 36.0808 30.2587 36.401 30.4915C36.1681 30.2587 36.0517 29.9531 36.0517 29.6329Z",
    fill: "url(#paint209_radial_578_447472)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4463 31.5685L39.4564 23.5786C38.9325 23.0547 38.9325 22.1961 39.4564 21.6722L47.4463 13.6823C47.9702 13.1583 48.8289 13.1583 49.3528 13.6823L57.3426 21.6722C57.8666 22.1961 57.8666 23.0547 57.3426 23.5786L49.3528 31.5685C48.8289 32.0925 47.9702 32.0925 47.4463 31.5685Z",
    fill: "url(#paint210_radial_578_447472)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4024 22.924C57.3442 23.1568 57.2278 23.3752 57.0531 23.5498L49.3252 31.2777C48.8158 31.7871 47.9863 31.7871 47.4915 31.2777L43.0672 26.8534L39.749 23.5352C39.6181 23.4043 39.5162 23.2442 39.458 23.0841C39.2688 22.6184 39.3707 22.0799 39.749 21.7015L47.477 13.9736C47.9863 13.4642 48.8159 13.4642 49.3107 13.9736L57.0386 21.7015C57.3733 22.0217 57.4897 22.4874 57.4024 22.924Z",
    fill: "url(#paint211_radial_578_447472)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8499 22.3567L47.5777 14.6288C48.0871 14.1194 48.9166 14.1194 49.4115 14.6288L57.1394 22.3567C57.2558 22.4732 57.3431 22.6042 57.4013 22.7497C57.4304 22.3859 57.2995 21.9929 57.023 21.7164L49.2951 13.9885C48.7857 13.4791 47.9561 13.4791 47.4613 13.9885L39.7334 21.7164C39.3404 22.1093 39.2531 22.6915 39.4714 23.1717C39.5006 22.8516 39.6316 22.575 39.8499 22.3567Z",
    fill: "url(#paint212_radial_578_447472)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0523 22.8952L49.3244 30.6231C48.815 31.1325 47.9855 31.1325 47.4907 30.6231L39.7628 22.8952C39.5882 22.7205 39.4863 22.5168 39.4135 22.2985C39.3117 22.7351 39.4135 23.2008 39.7628 23.5501L47.4907 31.278C48.0001 31.7874 48.8296 31.7874 49.3244 31.278L57.0523 23.5501C57.387 23.2153 57.5035 22.7351 57.4016 22.2985C57.3288 22.5168 57.227 22.7351 57.0523 22.8952Z",
    fill: "url(#paint213_radial_578_447472)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3438 23.4769L49.3539 31.4667C48.83 31.9907 47.9713 31.9907 47.4474 31.4667L39.4575 23.4769C39.2101 23.2295 39.0791 22.9093 39.0646 22.5891C39.05 22.9529 39.181 23.3168 39.4575 23.5933L47.4474 31.5831C47.9713 32.1071 48.83 32.1071 49.3539 31.5831L57.3438 23.5933C57.6203 23.3168 57.7513 22.9529 57.7367 22.5891C57.7222 22.8947 57.5912 23.2149 57.3438 23.4769Z",
    fill: "url(#paint214_radial_578_447472)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4561 23.4768L49.2522 30.6808C48.7719 31.1611 48.0151 31.1611 47.5349 30.6808L43.4308 26.5767L40.3309 23.4768C39.8506 22.9966 39.8506 22.2397 40.3309 21.7595L47.5349 14.5555C48.0151 14.0752 48.7865 14.0752 49.2522 14.5555L52.6868 17.9901L56.4561 21.7595C56.9364 22.2397 56.9364 23.0111 56.4561 23.4768Z",
    fill: "url(#paint215_radial_578_447472)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5721 21.7595L49.3681 14.5556C49.1207 14.3082 48.7859 14.1917 48.4512 14.2063C48.7422 14.2208 49.0333 14.3373 49.2516 14.5556L56.4556 21.7595C56.9359 22.2398 56.9359 22.9966 56.4556 23.4769L49.2516 30.6809C49.0188 30.9137 48.7422 31.0301 48.4512 31.0301C48.7859 31.0447 49.1061 30.9283 49.3681 30.6809L56.5721 23.4769C57.0378 23.0112 57.0378 22.2398 56.5721 21.7595Z",
    fill: "url(#paint216_radial_578_447472)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4575 21.6724L47.4474 13.6824C47.9713 13.1585 48.83 13.1585 49.3539 13.6824L57.3438 21.6724C57.5912 21.9198 57.7222 22.2399 57.7367 22.5601C57.7513 22.1962 57.6203 21.8324 57.3438 21.5559L49.3539 13.566C48.83 13.0421 47.9713 13.0421 47.4474 13.566L39.4575 21.5559C39.181 21.8324 39.05 22.1962 39.0646 22.5601C39.0646 22.2399 39.1956 21.9198 39.4575 21.6724Z",
    fill: "url(#paint217_radial_578_447472)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6368 30.5793L40.4328 23.3754C39.9525 22.8951 39.9525 22.1383 40.4328 21.6581L40.3309 21.7599C39.8506 22.2402 39.8506 22.997 40.3309 23.4773L47.5349 30.6812C48.0151 31.1615 48.7719 31.1615 49.2522 30.6812L49.3541 30.5793C48.8884 31.0596 48.117 31.0596 47.6368 30.5793Z",
    fill: "url(#paint218_radial_578_447472)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4551 23.4772L49.2511 30.6812C48.7708 31.1614 48.0141 31.1614 47.5338 30.6812L43.4297 26.5771C44.9869 23.9429 47.7957 20.5956 52.6857 17.976L56.4551 21.7454C56.9353 22.2402 56.9353 23.0115 56.4551 23.4772Z",
    fill: "url(#paint219_radial_578_447472)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0547 19.5663C45.3777 19.5787 45.651 19.6035 45.887 19.616C46.1106 19.6284 46.2969 19.6284 46.4336 19.6284C46.5951 19.6284 46.9305 19.6159 47.4274 19.5911C47.6137 19.5787 47.7628 19.5787 47.8498 19.5787V19.9762C47.5765 19.9886 47.3901 20.0259 47.3032 20.0632C47.2162 20.1005 47.179 20.1874 47.179 20.3116C47.179 20.3613 47.1914 20.4359 47.2038 20.5104C47.2162 20.585 47.2535 20.6719 47.2908 20.7712L48.856 25.2061L50.3343 20.7837C50.384 20.6719 50.4088 20.5849 50.4213 20.5352C50.4337 20.4855 50.4337 20.411 50.4337 20.3489C50.4337 20.2122 50.384 20.1129 50.2722 20.0508C50.1604 19.9886 49.9741 19.9638 49.7132 19.9638V19.5663C49.9616 19.5787 50.148 19.5911 50.3095 19.6035C50.471 19.616 50.5952 19.616 50.707 19.616C50.7939 19.616 50.9058 19.616 51.0424 19.6035C51.179 19.5911 51.3778 19.5911 51.6263 19.5663V19.9638C51.3902 19.9762 51.2287 20.0259 51.1418 20.088C51.0548 20.1501 50.9803 20.2495 50.943 20.3986L49.3405 25.0074C49.2411 25.2807 49.1417 25.5664 49.0299 25.8645C48.9181 26.1627 48.8063 26.4733 48.6821 26.7838L48.1852 26.7341L45.8746 20.6098L45.8622 20.5725C45.7131 20.1626 45.4522 19.9638 45.0795 19.9638L45.0547 19.5663Z",
    fill: "url(#paint220_radial_578_447472)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0547 19.5663C45.3777 19.5787 45.651 19.6035 45.887 19.616C46.1106 19.6284 46.2969 19.6284 46.4336 19.6284C46.5951 19.6284 46.9305 19.6159 47.4274 19.5911C47.6137 19.5787 47.7628 19.5787 47.8498 19.5787V19.9762C47.5765 19.9886 47.3901 20.0259 47.3032 20.0632C47.2162 20.1005 47.179 20.1874 47.179 20.3116C47.179 20.3613 47.1914 20.4359 47.2038 20.5104C47.2162 20.585 47.2535 20.6719 47.2908 20.7712L48.856 25.2061L50.3343 20.7837C50.384 20.6719 50.4088 20.5849 50.4213 20.5352C50.4337 20.4855 50.4337 20.411 50.4337 20.3489C50.4337 20.2122 50.384 20.1129 50.2722 20.0508C50.1604 19.9886 49.9741 19.9638 49.7132 19.9638V19.5663C49.9616 19.5787 50.148 19.5911 50.3095 19.6035C50.471 19.616 50.5952 19.616 50.707 19.616C50.7939 19.616 50.9058 19.616 51.0424 19.6035C51.179 19.5911 51.3778 19.5911 51.6263 19.5663V19.9638C51.3902 19.9762 51.2287 20.0259 51.1418 20.088C51.0548 20.1501 50.9803 20.2495 50.943 20.3986L49.3405 25.0074C49.2411 25.2807 49.1417 25.5664 49.0299 25.8645C48.9181 26.1627 48.8063 26.4733 48.6821 26.7838L48.1852 26.7341L45.8746 20.6098L45.8622 20.5725C45.7131 20.1626 45.4522 19.9638 45.0795 19.9638L45.0547 19.5663Z",
    fill: "url(#paint221_radial_578_447472)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7434 24.9082L47.2775 20.759C47.2403 20.6597 47.2154 20.5603 47.1906 20.4982C47.1657 20.436 47.1657 20.3615 47.1657 20.2994C47.1657 20.2248 47.1781 20.1627 47.2154 20.113C47.1409 20.1255 47.0912 20.1379 47.0539 20.1627C46.967 20.2124 46.9297 20.2869 46.9297 20.4112C46.9297 20.4609 46.9421 20.5354 46.9545 20.6099C46.967 20.6845 47.0042 20.7714 47.0415 20.8708L48.6067 25.3057L48.7434 24.9082Z",
    fill: "url(#paint222_radial_578_447472)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6383 19.7278C45.8619 19.7402 46.0482 19.7402 46.1849 19.7402C46.3464 19.7402 46.6818 19.7278 47.1787 19.7029C47.365 19.6905 47.5141 19.6905 47.6011 19.6905V19.9886C47.6756 19.9762 47.7501 19.9762 47.8371 19.9762V19.5787C47.7377 19.5787 47.6011 19.5911 47.4147 19.5911C46.9178 19.6159 46.5824 19.6284 46.4209 19.6284C46.2967 19.6284 46.1103 19.616 45.8743 19.616C45.6507 19.6035 45.365 19.5911 45.042 19.5663V19.7029C45.278 19.7154 45.4768 19.7153 45.6383 19.7278Z",
    fill: "#512B16"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0294 19.6036C50.8928 19.616 50.781 19.6161 50.694 19.6161C50.5822 19.6161 50.458 19.616 50.2965 19.6036C50.135 19.5912 49.9486 19.5912 49.7002 19.5664V19.703C49.8368 19.7155 49.9611 19.7154 50.0604 19.7154C50.2219 19.7278 50.3462 19.7278 50.458 19.7278C50.5449 19.7278 50.6567 19.7278 50.7934 19.7154C50.93 19.703 51.1288 19.703 51.3773 19.6782V19.9763C51.4518 19.9639 51.5263 19.9515 51.6133 19.9391V19.5415C51.3648 19.5788 51.1661 19.5912 51.0294 19.6036Z",
    fill: "#512B16"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8807 20.1995C50.7937 20.2492 50.7192 20.361 50.6819 20.5101L49.0794 25.1189C48.98 25.3922 48.8807 25.6779 48.7688 25.9761C48.6819 26.2245 48.5701 26.4854 48.4707 26.7587L48.657 26.7711C48.7813 26.4605 48.8931 26.15 49.0049 25.8518C49.1167 25.5537 49.2161 25.2679 49.3154 24.9946L50.918 20.3859C50.9552 20.2741 51.0049 20.1871 51.067 20.125C50.9925 20.1374 50.9304 20.1623 50.8807 20.1995Z",
    fill: "url(#paint223_radial_578_447472)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_578_447472",
    x1: 48.5807,
    y1: 53.5752,
    x2: 48.678,
    y2: 28.8557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE4600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3451 53.96) scale(29.6508 21.8805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AB92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_diamond_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5008 39.4933) rotate(88.3844) scale(2.95747 2.96383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.680957,
    stopColor: "#643020",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643020"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0532 37.8567) rotate(53.7462) scale(5.17777 5.1889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F1D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4945 37.2688) scale(5.60316 5.59419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#D19A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6232 40.4051) scale(2.87169 2.86709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5705 37.4595) scale(2.80159 2.7971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7088 38.724) scale(3.77813 3.77208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9608 40.9732) scale(2.27606 2.27242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8473 38.4902) scale(2.61133 2.60715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4331 38.6314) scale(3.90467 3.89842)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0744 42.4792) scale(3.99655 3.99015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1397 37.4328) scale(2.40371 2.39986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5296 38.8142) scale(5.43127 5.42258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FBE0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5206 37.456) scale(3.53283 3.52717)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FBE0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5214 41.4202) scale(3.1312 3.12618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5214 41.4202) scale(3.1312 3.12619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.394 38.6877) scale(2.48655 2.48257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4546 40.5112) scale(2.16265 2.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5167 39.5482) rotate(-90) scale(2.15918 2.16264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4697 39.4504) rotate(90) scale(2.15918 2.16265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5526 38.4867) rotate(180) scale(2.16265 2.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2239 40.9931) scale(5.60316 5.59419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#D19A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.3527 44.1293) scale(2.87169 2.86709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.3 41.1837) scale(2.80159 2.7971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.4382 42.4482) scale(3.77813 3.77208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.6902 44.6974) scale(2.27606 2.27242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5768 42.2144) scale(2.61133 2.60715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1626 42.3557) scale(3.90467 3.89842)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.8039 46.2034) scale(3.99655 3.99015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.8692 41.157) scale(2.40371 2.39986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.259 42.5385) scale(5.43127 5.42258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FBE0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2501 41.1802) scale(3.53283 3.52717)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FBE0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2509 45.1445) scale(3.1312 3.12618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2509 45.1444) scale(3.1312 3.12619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.1235 42.4119) scale(2.48655 2.48257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1841 44.2354) scale(2.16265 2.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2462 43.2724) rotate(-90) scale(2.15918 2.16264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.1992 43.1746) rotate(90) scale(2.15918 2.16265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2821 42.211) rotate(180) scale(2.16265 2.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3148 44.3722) scale(5.60316 5.59419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#D19A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4425 47.5086) scale(2.87169 2.86709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3898 44.5633) scale(2.80159 2.7971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5281 45.8274) scale(3.77813 3.77207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7801 48.0767) scale(2.27607 2.27242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6676 45.5937) scale(2.61133 2.60715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.2534 45.7348) scale(3.90467 3.89842)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.8947 49.5827) scale(3.99656 3.99015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.96 44.5361) scale(2.40371 2.39986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3499 45.9176) scale(5.43127 5.42258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FBE0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.341 44.5595) scale(3.53283 3.52717)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FBE0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3417 48.5236) scale(3.1312 3.12618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3417 48.5236) scale(3.1312 3.12619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2143 45.7911) scale(2.48655 2.48257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2749 47.6147) scale(2.16265 2.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.337 46.6516) rotate(-90) scale(2.15918 2.16265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2901 46.5538) rotate(90) scale(2.15918 2.16265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3729 45.5901) rotate(180) scale(2.16265 2.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.2913 40.9941) scale(5.60316 5.59419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#D19A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4201 44.1304) scale(2.87169 2.86709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.3674 41.1851) scale(2.80159 2.7971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5056 42.4492) scale(3.77813 3.77207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7576 44.6985) scale(2.27607 2.27242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6442 42.2155) scale(2.61133 2.60715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.23 42.3567) scale(3.90467 3.89842)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.8713 46.2044) scale(3.99656 3.99015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9366 41.158) scale(2.40371 2.39986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3274 42.5394) scale(5.43127 5.42258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FBE0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3175 41.1812) scale(3.53283 3.52717)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FBE0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3183 45.1455) scale(3.1312 3.12618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3183 45.1454) scale(3.1312 3.12619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1909 42.4129) scale(2.48655 2.48257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.2514 44.2365) scale(2.16265 2.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.3136 43.2734) rotate(-90) scale(2.15918 2.16265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2666 43.1756) rotate(90) scale(2.15918 2.16265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3494 42.2119) rotate(180) scale(2.16265 2.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2679 37.3561) scale(5.60316 5.59419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#D19A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.3966 40.4924) scale(2.87169 2.86709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.3439 37.5468) scale(2.80159 2.7971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.4822 38.8111) scale(3.77813 3.77207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.7342 41.0605) scale(2.27607 2.27242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.6208 38.5774) scale(2.61133 2.60715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.2065 38.7187) scale(3.90467 3.89842)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.8478 42.5663) scale(3.99656 3.99015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.9132 37.5199) scale(2.40371 2.39986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.303 38.9014) scale(5.43127 5.42258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FBE0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2941 37.5432) scale(3.53283 3.52717)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FBE0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2949 41.5074) scale(3.1312 3.12618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2949 41.5073) scale(3.1312 3.12619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.1674 38.7748) scale(2.48655 2.48257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.228 40.5984) scale(2.16265 2.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.2901 39.6355) rotate(-90) scale(2.15918 2.16265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.2432 39.5375) rotate(90) scale(2.15918 2.16265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.326 38.5739) rotate(180) scale(2.16265 2.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1895 50.664) scale(18.5938 6.80942)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#763C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C2704C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#8A502D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2041 17.5727) rotate(-157.01) scale(15.9293 15.9293)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0672 26.7549) rotate(-157.01) scale(14.7862 14.7863)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B46140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.997 23.6989) rotate(-157.01) scale(6.55717 6.5572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.8437 27.1021) rotate(-157.01) scale(4.16079 4.16086)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55838",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5171 5.86449) rotate(-157.01) scale(24.0512 24.0513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.2965 24.2465) rotate(22.9898) scale(10.6131 10.6132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2186 29.3238) rotate(-157.01) scale(0.026641 0.0130484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.211 23.7828) rotate(-157.01) scale(15.7961 7.73657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2134 21.7096) rotate(24.5811) scale(10.7987 3.02859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#894D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D5537",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9763 28.9688) rotate(22.9898) scale(17.7201 17.7201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9763 28.9688) rotate(22.9898) scale(17.7201 17.7201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0698 9.84919) rotate(-157.01) scale(18.0519 18.052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.2989 18.0538) rotate(-22.9898) scale(15.9293 15.9293)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.4358 27.2361) rotate(-22.9898) scale(14.7862 14.7863)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B46140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.5059 24.1801) rotate(-22.9898) scale(6.55717 6.5572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.6592 27.5833) rotate(-22.9898) scale(4.16079 4.16086)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55838",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.9858 6.34557) rotate(-22.9898) scale(24.0512 24.0513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.2064 24.7277) rotate(157.01) scale(10.6131 10.6132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2843 29.805) rotate(-22.9898) scale(0.026641 0.0130484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.292 24.264) rotate(-22.9898) scale(15.7961 7.73657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.2895 22.1908) rotate(155.419) scale(10.7987 3.02859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#894D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D5537",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.5266 29.4499) rotate(157.01) scale(17.7201 17.7201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.5266 29.4499) rotate(157.01) scale(17.7201 17.7201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.4331 10.3304) rotate(-22.9898) scale(18.0519 18.052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4287 22.5909) rotate(-165) scale(12.9614 12.9614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.1626 29.8922) rotate(-165) scale(12.0313 12.0314)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B46140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1778 27.0984) rotate(-165) scale(5.33547 5.33549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4389 29.8579) rotate(-165) scale(3.38557 3.38562)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55838",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1625 13.0081) rotate(-165) scale(19.5701 19.5702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4802 27.5057) rotate(15) scale(8.63574 8.6358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4385 30.701) rotate(-165) scale(0.0216774 0.0106172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1366 27.5941) rotate(-165) scale(12.853 6.29513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5438 25.1316) rotate(16.5914) scale(8.78673 2.46431)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#894D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D5537",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9803 30.8947) rotate(15) scale(14.4186 14.4186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9803 30.8947) rotate(15) scale(14.4186 14.4186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5824 17.6267) rotate(-165) scale(14.6885 14.6886)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.293 22.5909) rotate(-15) scale(12.9614 12.9614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.5591 29.8922) rotate(-15) scale(12.0313 12.0314)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B46140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.5439 27.0984) rotate(-15) scale(5.33547 5.33549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.2828 29.8579) rotate(-15) scale(3.38557 3.38562)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55838",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.5592 13.0081) rotate(-15) scale(19.5701 19.5702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.2415 27.5057) rotate(165) scale(8.63574 8.6358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.2832 30.701) rotate(-15) scale(0.0216774 0.0106172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.585 27.5941) rotate(-15) scale(12.853 6.29513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.1769 25.1317) rotate(163.409) scale(8.78673 2.46431)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#894D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D5537",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7414 30.8947) rotate(165) scale(14.4186 14.4186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7414 30.8947) rotate(165) scale(14.4186 14.4186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.1392 17.6267) rotate(-15) scale(14.6885 14.6886)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1147 26.7547) rotate(180) scale(10.414 10.414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9784 32.0605) rotate(180) scale(9.66663 9.66672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B46140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9614 29.4731) rotate(180) scale(4.28682 4.28684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7381 31.5606) rotate(180) scale(2.72017 2.72021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55838",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.9154 19.373) rotate(180) scale(15.7237 15.7238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2816 29.7263) scale(6.93845 6.9385)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3454 30.7594) rotate(180) scale(0.0175531 0.00859722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.7044 30.4903) rotate(180) scale(10.3269 5.05787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3889 27.4546) rotate(1.59136) scale(7.05977 1.97997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#894D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D5537",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7021 31.6287) scale(11.5847 11.5847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7021 31.6287) scale(11.5847 11.5847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4414 24.9494) rotate(180) scale(11.8016 11.8017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.6025 26.7543) scale(10.414 10.414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.7381 32.0602) scale(9.66663 9.66672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B46140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.7549 29.4729) scale(4.28684 4.28684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.9779 31.5603) scale(2.72017 2.72021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55838",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.801 19.3726) scale(15.7238 15.7238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.4356 29.7261) rotate(180) scale(6.93848 6.9385)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0116 30.4901) scale(10.3269 5.05787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.3926 27.46) rotate(178.409) scale(7.05972 1.97997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#894D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D5537",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0151 31.6283) rotate(180) scale(11.5848 11.5847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.2759 24.9492) scale(11.8017 11.8017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0659 23.8249) scale(7.94029 7.94037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753B1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.214 16.246) scale(13.4471 13.4471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.8565 21.7031) scale(8.00833 8.00835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0014 29.3113) scale(14.3373 14.3374)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0321 22.7815) rotate(90) scale(10.1136 7.52335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.2879 23.6055) rotate(180) scale(7.94042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753B1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.1395 16.0256) rotate(180) scale(13.4471 13.4471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.4969 21.4829) rotate(180) scale(8.00833 8.00829)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.3519 29.0908) rotate(180) scale(14.3373 14.3372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.6555 22.4476) rotate(90) scale(9.91234 7.19411)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5124 9.93614) rotate(60) scale(7.94029 7.94037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753B1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6505 10.6054) rotate(60) scale(13.4471 13.4471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2455 8.69395) rotate(60) scale(8.00832 8.00835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2293 16.9539) rotate(60) scale(14.3373 14.3374)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.8995 15.4476) rotate(150) scale(10.1136 7.52335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.0853 9.93614) rotate(120) scale(7.94029 7.94037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753B1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9481 10.6054) rotate(120) scale(13.4471 13.4471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.3531 8.69407) rotate(120) scale(8.00832 8.00835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3693 16.9539) rotate(120) scale(14.3373 14.3374)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6992 15.4476) rotate(30) scale(10.1136 7.52335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.1283 24.6681) scale(6.7016 6.70166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753B1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4736 18.2716) scale(11.3493 11.3493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9519 22.8772) scale(6.75902 6.75904)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2936 29.2987) scale(12.1007 12.1007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0081 23.7875) rotate(90) scale(8.53587 6.3497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.3883 24.4829) rotate(180) scale(6.7017 6.7017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753B1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0431 18.0856) rotate(180) scale(11.3493 11.3493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.5647 22.6914) rotate(180) scale(6.75902 6.75899)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2223 29.1125) rotate(180) scale(12.1007 12.1006)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.7898 23.5057) rotate(90) scale(8.36601 6.07182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3653 38.6927) scale(18.4074 18.4073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_578_447472",
    x1: 48.3653,
    y1: 1.74983,
    x2: 48.3653,
    y2: 49.2099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3653 3.52178) scale(32.684 32.6839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8193 34.5713) scale(16.6956 16.6956)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5212 23.9053) scale(29.3528 7.39871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7029 20.7987) rotate(-0.182297) scale(35.3415 7.65073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#894D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#AA765A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.8712 8.70331) scale(28.9109 28.9109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0771 45.7195) scale(0.0537825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_578_447472",
    x1: 48.3485,
    y1: 39.4042,
    x2: 48.3485,
    y2: 2.42403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5322 15.9062) scale(25.0522 25.0522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#F4A076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.4809 21.3646) scale(20.9268 20.9268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8A27F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B24E1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5324 11.708) scale(10.4883 10.4883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3485 34.4627) scale(19.7517 19.7516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_578_447472",
    x1: 48.348,
    y1: 5.46642,
    x2: 48.348,
    y2: 38.5374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#933612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4968,
    stopColor: "#E48D65",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#963A16",
    stopOpacity: 0.9811
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.775 24.4991) scale(19.2249 19.2248)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6009 32.5362) scale(22.4772 22.4773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B56748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C472C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2933 16.5989) scale(23.625 23.6251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A279"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5068 13.7698) scale(16.2953 16.2954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC6AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5474 29.9967) scale(18.4745 18.4746)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED9266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#FFC8AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2141 32.5697) scale(20.6755 20.6754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA67F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2978 17.005) scale(22.0325 22.0326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A279"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2112 19.185) scale(11.9848 11.9847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC6AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6265 12.9433) scale(11.5818 11.5818)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA67F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.8741 27.4766) scale(6.62182 6.62182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC6AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.002 20.3521) scale(12.3887 12.3887)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC6AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.952 18.4863) scale(23.4827 10.8639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.952 18.4863) scale(23.4827 10.8639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.1253 18.0854) scale(27.4296 12.9191)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_578_447472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8877 17.5298) scale(39.2657 16.5353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB775A",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.a3afc14e2b56159ed4b994cebca832aa.svg";
export { ForwardRef as ReactComponent };